{
  "nav": {
    "dashboard": "Tableau de bord",
    "teacherDashboard": "Tableau de bord formateur",
    "projects": "Projets",
    "fairQuote": "Devis rapide",
    "exitFairQuote": "Quitter le devis rapide",
    "calendar": "Calendrier",
    "products": "Produits",
    "colors": "Couleurs",
    "company": "Entreprise",
    "contacts": "Contacts",
    "applicatorProfiles": "Applicateurs",
    "courses": "Formations",
    "certifications": "Certifications",
    "certificationDefinitions": "Définitions de certification",
    "userManagement": "Gestion des utilisateurs",
    "switchEntity": "Changer d'entité",
    "entities": "Entités",
    "staff": "Personnel",
    "overview": "Aperçu",
    "sections": {
      "projects": "Projets",
      "shop": "Boutique",
      "learning": "Formation",
      "admin": "Administration",
      "entity": "Entité"
    }
  },
  "materialTracking": {
    "title": "Commande Matériel",
    "status": {
      "Draft": "À commander",
      "Ordered": "Commandé",
      "PartiallyDelivered": "Livraison partielle",
      "Delivered": "Livré"
    },
    "statusLate": "Livraison en retard",
    "late": "EN RETARD",
    "markOrdered": "Marquer comme commandé",
    "markOrderedTitle": "Confirmer la commande",
    "markOrderedHint": "Indiquez que le matériel a été commandé. Vous pouvez renseigner une date de livraison estimée.",
    "estimatedDelivery": "Date de livraison estimée",
    "estimatedDeliveryPlaceholder": "Choisir une date",
    "orderedOn": "Commandé le",
    "validateDelivery": "Valider la réception",
    "addDeliveryTitle": "Enregistrer une livraison",
    "addDeliveryHint": "Indiquez ce qui a été effectivement reçu. Ajustez les quantités si nécessaire.",
    "deliveryComplete": "Livraison complète",
    "deliveryPartial": "Livraison partielle",
    "deliveries": "Livraisons",
    "noLines": "Aucun article enregistré",
    "addLine": "Ajouter un article",
    "confirmDelivery": "Enregistrer la livraison",
    "deleteDeliveryTitle": "Supprimer la livraison",
    "deleteDeliveryConfirm": "Voulez-vous vraiment supprimer cet enregistrement de livraison ?",
    "addStock": "Ajouter du stock",
    "addStockTitle": "Ajout de stock manuel",
    "manualStock": "Stock manuel",
    "stockDescription": "Description",
    "stockDescriptionPlaceholder": "ex. Sac récupéré d'un chantier précédent",
    "stockNotesPlaceholder": "ex. Récupéré villa Martin",
    "deleteStockTitle": "Supprimer l'entrée de stock",
    "deleteStockConfirm": "Voulez-vous vraiment supprimer cette entrée de stock ?",
    "productName": "Produit",
    "quantity": "Qté",
    "unit": "Unité",
    "unitPlaceholder": "ex. sac 25 kg",
    "notes": "Notes",
    "notesPlaceholder": "Note optionnelle",
    "deliveryNotesPlaceholder": "ex. Articles endommagés, manquants",
    "confirmOrder": "Confirmer la commande",
    "draftHint": "Aucune commande enregistrée. Cliquez sur « Marquer comme commandé » une fois la commande passée.",
    "consumption": "Besoins en matériaux",
    "productList": "Produits à commander",
    "order": "Commander",
    "orderOnShopify": "Commander sur masmaya.com",
    "orderAlerts": "Alertes commandes",
    "daysLate": "{{count}} jour de retard",
    "daysLate_other": "{{count}} jours de retard",
    "sectionOrderWarningTitle": "Commande pour cette section uniquement",
    "sectionOrderWarningBody": "Commander pour cette seule section peut revenir plus cher que pour l'ensemble du projet : le projet global atteint parfois des paliers de quantité (sacs de 300 kg ou 1000 kg) inaccessibles section par section, surtout si l'accès chantier permet ces gros conditionnements. Pense à vérifier le total du projet avant de commander.",
    "sectionOrderWarningConfirm": "Commander quand même"
  },
  "assignedPeople": {
    "add": "Ajouter une personne",
    "search": "Rechercher…",
    "noResults": "Aucun résultat",
    "replace": "Remplacer",
    "remove": "Retirer"
  },
  "common": {
    "login": "Connexion",
    "error": "Une erreur s'est produite",
    "goHome": "Retour à l'accueil",
    "loading": "Chargement...",
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Enregistrer",
    "edit": "Modifier",
    "remove": "Retirer",
    "archive": "Archiver",
    "delete": "Supprimer",
    "open": "Ouvrir",
    "add": "Ajouter",
    "close": "Fermer",
    "zoom": "Zoomer",
    "back": "Retour",
    "rename": "Renommer",
    "unsavedChanges": "Modifications non enregistrées",
    "discardChangesTitle": "Abandonner les modifications ?",
    "discardChangesConfirm": "Vous avez des modifications non enregistrées. Voulez-vous vraiment les abandonner ?",
    "discardChangesAction": "Abandonner",
    "view": "Voir",
    "search": "Rechercher…",
    "tooManyResults": "Trop de résultats, affinez votre recherche",
    "change": "Modifier",
    "notFound": "Non trouvé",
    "next": "Suivant",
    "confirm": "Confirmer",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "total": "Total"
  },
  "user": {
    "profile": "Profil",
    "logout": "Se déconnecter",
    "noEntity": "Aucune entité sélectionnée"
  },
  "products": {
    "title": "Produits",
    "createButton": "Nouveau produit",
    "createTitle": "Créer un produit",
    "editTitle": "Modifier le produit",
    "importButton": "Importer CSV",
    "shopifySync": {
      "button": "Synchroniser depuis Shopify",
      "successTitle": "Synchronisation Shopify terminée",
      "successMessage": "{{updated}} produits mis à jour, {{created}} créés",
      "error": "Échec de la synchronisation Shopify"
    },
    "searchPlaceholder": "Rechercher par nom, variante ou catégorie...",
    "allCategories": "Toutes les catégories",
    "excludeSamples": "Exclure les échantillons",
    "noData": "Aucun produit trouvé",
    "grouped": "Groupé",
    "table": "Tableau",
    "columns": {
      "category": "Catégorie",
      "name": "Nom",
      "variant": "Variante",
      "color": "Couleur",
      "sizeWeight": "Taille / Poids",
      "dimensions": "Dimensions",
      "price": "Prix (EUR)"
    },
    "form": {
      "category": "Catégorie",
      "categoryRequired": "La catégorie est requise",
      "name": "Nom du produit",
      "nameRequired": "Le nom est requis",
      "variant": "Variante",
      "variantRequired": "La variante est requise",
      "color": "Couleur",
      "sizeWeight": "Taille / Poids",
      "dimensions": "Dimensions",
      "price": "Prix (EUR)",
      "priceRequired": "Le prix doit être supérieur ou égal à 0",
      "sku": "SKU",
      "imageUrl": "URL de l'image",
      "shopifyVariantId": "ID variante Shopify"
    },
    "delete": {
      "title": "Supprimer le produit",
      "confirm": "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible."
    },
    "import": {
      "title": "Importer des produits depuis un CSV",
      "description": "Importez un fichier séparé par des tabulations (.csv / .tsv) avec les colonnes suivantes :",
      "selectFile": "Choisir un fichier",
      "action": "Importer",
      "success": "Importation réussie",
      "imported": "{{count}} produits importés.",
      "close": "Fermer"
    },
    "backToList": "Retour aux produits"
  },
  "language": {
    "label": "Langue",
    "en": "Anglais",
    "fr": "Français",
    "de": "Allemand"
  },
  "pages": {
    "login": {
      "pageTitle": "Connexion"
    },
    "notFound": {
      "message": "Page non trouvée",
      "title": "Oups"
    },
    "milestones": {
      "pageTitle": "Jalons"
    },
    "staff": {
      "pageTitle": "Personnel"
    },
    "taskGeneration": {
      "pageTitle": "Génération des tâches"
    },
    "quote": {
      "pageTitle": "Devis"
    },
    "roomCalculation": {
      "pageTitle": "Calcul pièce"
    },
    "company": {
      "pageTitle": "Entreprise"
    },
    "entityDetail": {
      "pageTitle": "Détail de l'entité"
    },
    "entities": {
      "pageTitle": "Entités"
    }
  },
  "projects": {
    "title": "Projets",
    "createButton": "Nouveau projet",
    "createTitle": "Créer un projet",
    "editTitle": "Modifier le projet",
    "searchPlaceholder": "Rechercher par nom...",
    "allStatuses": "Tous les statuts",
    "noData": "Aucun projet trouvé",
    "late": "En retard",
    "noClient": "Aucun client assigné",
    "presentationMode": {
      "enter": "Activer le mode présentation (masque les prix et les notes internes)",
      "exit": "Quitter le mode présentation"
    },
    "tracking": {
      "title": "Suivi"
    },
    "sequenceGenerator": {
      "title": "Générer la séquence de tâches",
      "description": "Générez automatiquement une séquence de tâches Mas Maya planifiée et ordonnée pour une section de projet.",
      "sectionLabel": "Section",
      "startDateLabel": "Date de début",
      "generatingPreview": "Génération de l'aperçu…",
      "generatedSequence": "Séquence générée",
      "steps": "étapes",
      "calendarDays": "jours calendaires",
      "work": "travail",
      "dry": "séchage",
      "cure": "cure",
      "generationFailed": "Échec de la génération",
      "unexpectedError": "Une erreur inattendue s'est produite. Veuillez réessayer.",
      "confirmAndGenerate": "Confirmer et générer",
      "createStepsAndTasks": "Créer les étapes et tâches",
      "cancel": "Annuler",
      "premiumFinish": "Finition Premium",
      "repair": "Réparation",
      "highTraffic": "Trafic élevé",
      "confirmMessage": "Cela créera <1>{{stepCount}} étapes de projet</1> et <2>{{taskCount}} tâches</2> dans le projet. Les étapes et tâches existantes ne seront pas supprimées.",
      "taskCount_one": "{{count}} tâche",
      "taskCount_other": "{{count}} tâches",
      "photoLabel": "{{count}}+ photos",
      "stepTypes": {
        "SubstratePreparation": "Préparation du support",
        "PrimerApplication": "Application du primaire",
        "BaseLayer": "Couche de base",
        "MeshInstallation": "Pose du mesh",
        "FinishingCoat": "Couche de finition",
        "Smoothing": "Lissage",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-Duty Sealer",
        "CuringStep": "Période de cure",
        "ProtectionPeriod": "Période de protection",
        "Handover": "Remise client"
      }
    },
    "columns": {
      "name": "Nom",
      "status": "Statut",
      "manager": "Chef de projet",
      "entity": "Entité",
      "startDate": "Début",
      "endDate": "Fin"
    },
    "status": {
      "Draft": "Brouillon",
      "Planned": "Planifié",
      "InProgress": "En cours",
      "OnHold": "En pause",
      "Completed": "Terminé",
      "Archived": "Archivé",
      "AwaitingDelivery": "Attente livraison",
      "Blocked": "Bloqué",
      "AwaitingValidation": "En attente validation",
      "CorrectionRequired": "Correction requise"
    },
    "executionMode": {
      "ExternalOnly": "Projet DIY",
      "MasMayaManaged": "Mas Maya Certified Applicator",
      "MasMayaExecuted": "Mas Maya Executed",
      "ExternalOnlyDescription": "Le client réalise les travaux lui-même",
      "MasMayaManagedDescription": "Applicateur certifié Mas Maya",
      "MasMayaExecutedDescription": "Réalisé par les équipes Mas Maya"
    },
    "applicators": {
      "title": "Équipe applicateurs",
      "selectLabel": "Ajouter un applicateur",
      "selectPlaceholder": "Rechercher un applicateur interne...",
      "assign": "Affecter",
      "empty": "Aucun applicateur affecté pour l'instant — utilisez le sélecteur ci-dessus pour en ajouter un.",
      "requiresDates": "Définissez les dates de début et de fin planifiées sur le projet avant d'affecter des applicateurs.",
      "removeTitle": "Retirer l'applicateur",
      "removeConfirm": "Retirer {{name}} de l'équipe applicateurs ?"
    },
    "sections": {
      "general": "Informations générales",
      "contact": "Contact principal",
      "documents": "Documents"
    },
    "form": {
      "name": "Nom",
      "nameRequired": "Le nom est requis",
      "entity": "Entité",
      "entityRequired": "L'entité est requise",
      "manager": "Chef de projet",
      "managerRequired": "Le chef de projet est requis",
      "managerPlaceholder": "Rechercher un utilisateur...",
      "managerNoResults": "Aucun utilisateur trouvé",
      "status": "Statut",
      "date": "Date",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "endDateNoSections": "Aucune section",
      "endDateCalculating": "Calcul en cours...",
      "surface": "Surface totale (m²)",
      "description": "Description",
      "notes": "Notes",
      "primaryContact": "Contact principal",
      "primaryContactPlaceholder": "Rechercher un contact...",
      "primaryContactNoResults": "Aucun contact trouvé",
      "primaryContactClear": "— Retirer le contact",
      "executionMode": "Mode d'exécution",
      "country": "Pays",
      "countryRequired": "Le pays est obligatoire",
      "addressLine1": "Adresse",
      "city": "Ville",
      "projectTypeTitle": "Type de projet",
      "projectTypeSubtitle": "Quel type de chantier est-ce ?",
      "sectionSourceTitle": "Comment souhaitez-vous créer les sections ?",
      "sectionSourceSubtitle": "Vous pourrez toujours en ajouter ou en importer plus tard.",
      "namePlaceholder": "Résidence Les Pins, Villa Dupont…"
    },
    "delete": {
      "title": "Supprimer le projet",
      "confirm": "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible.",
      "action": "Supprimer"
    },
    "documents": {
      "dropzoneTitle": "Déposez des fichiers ici ou cliquez pour téléverser",
      "dropzoneHint": "Tout type de fichier accepté",
      "preview": "Aperçu",
      "previewUnavailable": "Aperçu non disponible pour ce type de fichier",
      "download": "Télécharger",
      "rename": "Renommer",
      "removeTitle": "Retirer le document",
      "removeConfirm": "Retirer \"{{name}}\" de ce projet ?"
    },
    "resources": {
      "title": "Ressources",
      "professionalContacts": "Contacts professionnels",
      "addTitle": "Ajouter une ressource",
      "email": "Email",
      "emailPlaceholder": "nom@exemple.com",
      "displayName": "Prénom et nom",
      "displayNamePlaceholder": "Jean Dupont",
      "role": "Rôle",
      "removeTitle": "Retirer la ressource",
      "removeConfirm": "Retirer {{name}} de ce projet ?",
      "columns": {
        "name": "Nom",
        "email": "Email",
        "role": "Rôle",
        "linked": "Compte"
      },
      "empty": "Aucun membre d'équipe assigné pour l'instant — ajoutez-en un ci-dessous.",
      "linked": "Lié",
      "pending": "En attente",
      "roles": {
        "PM": "Chef de projet",
        "Worker": "Ouvrier",
        "QualityManager": "Responsable Qualité"
      },
      "noAvailable": "Personne disponible à assigner",
      "certifiedGroup": "Applicateurs certifiés",
      "selectCertifiedCompanies": "Entreprises avec applicateur certifié"
    },
    "projectSections": {
      "title": "Sections",
      "createTitle": "Ajouter une section",
      "editTitle": "Modifier la section",
      "add": "Ajouter une section",
      "empty": "Aucune section",
      "wet": "Humide",
      "submerged": "Immergé",
      "protected": "Protégé",
      "exterior": "Extérieur",
      "renameFloor": "Renommer l'étage",
      "deleteTitle": "Supprimer la section",
      "deleteConfirm": "Supprimer la section \"{{label}}\" ? Cette action est irréversible.",
      "columns": {
        "label": "Libellé",
        "color": "Couleur",
        "type": "Type",
        "surface": "Surface",
        "finish": "Finition",
        "surfaceM2": "Surface",
        "flags": "Options",
        "workers": "Ouvriers"
      },
      "stepProgress": "Étape {{current}} sur {{total}}"
    },
    "sectionForm": {
      "label": "Libellé",
      "color": "Couleur",
      "colorPlaceholder": "Rechercher une couleur...",
      "colorClear": "— Retirer la couleur",
      "colorNoResults": "Aucune couleur trouvée",
      "type": "Type",
      "roomSubtype": "Sous-type",
      "substrate": "Support",
      "finish": "Finition",
      "surfaceM2": "Surface (m²)",
      "exposure": "Exposition",
      "condition": "État du support",
      "traffic": "Trafic",
      "insideCornerLinearM": "Angles rentrants (ml)",
      "insideCornerHint": "Ne pas plier le mesh aux angles rentrants",
      "outsideCornerLinearM": "Angles sortants (ml)",
      "outsideCornerHint": "Mesh enroulé 10 cm de chaque côté",
      "isCurved": "Surface courbe",
      "isCurvedHint": "Voûte, colonne, cintre (+15 % déchets)",
      "isRepair": "Réparation / petite retouche",
      "isRepairHint": "Quantités minimales forfaitaires",
      "roomWidthM": "Largeur (m)",
      "roomLengthM": "Longueur (m)",
      "roomHeightM": "Hauteur (m)",
      "includedSurfaces": "Surfaces incluses",
      "coatFloor": "Sol",
      "coatWalls": "Murs",
      "coatCeiling": "Plafond",
      "roomHeightPlaceholder": "Hauteur non renseignée — 2,5 m utilisé par défaut pour les calculs",
      "surfaceConfig": "Configuration par surface",
      "selectSubstrate": "Sélectionner un support...",
      "selectFinish": "Sélectionner une finition...",
      "surface": {
        "floor": "Sol",
        "walls": "Murs",
        "ceiling": "Plafond"
      },
      "roomBreakdown": {
        "surfaceM2": "Surface pièce",
        "heightM": "Hauteur",
        "heightCoefficient": "Coefficient hauteur",
        "floorM2": "Sol calculé",
        "wallsM2": "Murs calculés",
        "ceilingM2": "Plafond calculé",
        "totalM2": "Total calculé :",
        "placeholderHeightWarning": "Hauteur non renseignée — 2,5 m utilisée temporairement pour le calcul",
        "noRoomParams": "Configuration de calcul non disponible"
      },
      "repairForfaitBadge": "Forfait",
      "workers": "Ouvriers assignés",
      "workersPlaceholder": "Sélectionner des ouvriers...",
      "quantityPreview": "Aperçu des quantités",
      "layerCount": "couche(s)",
      "meshForcedNotice": "Mesh obligatoire pour ce type de support — non désactivable",
      "waterproofMembrane": "Membrane d'étanchéité",
      "waterproofConfirmed": "Présente et confirmée",
      "waterproofAbsent": "Absente ou non vérifiée",
      "waterproofUnknown": "Sélectionner...",
      "waterproofExplanation": "Mas Maya est un revêtement résistant à l'eau, non un système d'étanchéité. Une membrane d'étanchéité (ex. Schlüter-KERDI, Aqua-Panel) doit être posée préalablement en zone humide.",
      "waterproofBlockingWarning": "Impossible de sauvegarder : une membrane d'étanchéité confirmée est obligatoire pour les zones humides.",
      "waterproofToPose": "Membrane à poser",
      "waterproofWillBeAdded": "Aucune membrane présente — la membrane et les renforts d'angle/traversée de tuyau seront ajoutés au panier matériel.",
      "insideCornerCount": "Nombre d'angles entrants",
      "insideCornerCountHint": "Nombre de renforts d'angle entrant à poser (ex. 4 pour une piscine rectangulaire)",
      "outsideCornerCount": "Nombre d'angles sortants",
      "outsideCornerCountHint": "Nombre de renforts d'angle sortant à poser",
      "pipePenetrationCount": "Nombre de traversées de tuyau",
      "pipePenetrationCountHint": "Nombre de renforts de traversée de tuyau à poser",
      "system": {
        "standard1Layer": "Sec — 1 couche",
        "premium2Layers": "Sec — 2 couches",
        "mesh2Layers": "Mesh — 2 couches",
        "pool": "Piscine — Système critique",
        "exterior": "Extérieur — Façade",
        "exteriorFloor": "Extérieur — Sol / Terrasse"
      },
      "riskLevel": {
        "low": "Risque faible",
        "medium": "Risque modéré",
        "high": "Risque élevé",
        "very-high": "Risque très élevé",
        "critical": "Risque critique"
      },
      "warnings": {
        "deterioratedSupport": "Support dégradé — Préparation (Prep) obligatoire",
        "tilesAlwaysMesh": "Carrelage existant — Prep + mesh obligatoires (mouvement des joints)",
        "floorMesh": "Sol — Mesh + Presealer + Sealer obligatoires",
        "stepsMeshNosing": "Escaliers — Mesh enroulé sur nez de marche, Presealer + Sealer inclus",
        "brickBlockMesh": "Support avec joints — Mesh obligatoire",
        "plasterboardMovement": "Placo / cloison — Risque de mouvement, mesh obligatoire",
        "wetZone": "Salle de bain (sans contact direct) — Mesh + protection requises",
        "directWaterZone": "Contact direct avec l'eau — Pool Primer sélectionné automatiquement",
        "waterproofMembraneRequired": "Membrane d'étanchéité obligatoire — à confirmer avant pose",
        "masMayaWaterResistant": "Mas Maya est résistant à l'eau mais non étanche — membrane préalable obligatoire",
        "submergedZone": "Zone immergée — Primer piscine + mesh",
        "exteriorExposure": "Exposition extérieure — Protection UV requise",
        "sealingRequired": "Protection demandée — Presealer + Sealer inclus",
        "heavyDutyRecommended": "Heavy-Duty Sealer recommandé pour ce type de surface",
        "poolWaterproofMembrane": "Piscine — Membrane d'étanchéité obligatoire avant Pool Primer",
        "poolWaterline": "Heavy-Duty Sealer obligatoire à la ceinture (±20 cm au niveau de l'eau)",
        "poolAftercare3Weeks": "Idéalement 3 semaines d'attente avant la mise en eau",
        "exteriorFacadeMesh": "Façade extérieure — Mesh + Presealer + Sealer requis",
        "drainageSlopeWarning": "Vérifier la pente (min 1,5 %) et le drainage avant application",
        "exteriorHeavyDuty": "Sol extérieur — Heavy-Duty Sealer obligatoire (résistance UV + trafic)",
        "curingTime72h": "Temps de séchage final : 72h minimum après dernière couche de sealer",
        "furnitureMesh": "Bois / MDF — Risque de mouvement, mesh obligatoire",
        "insideCornerNoFold": "Angles rentrants — Ne pas plier le mesh, couper et chevaucher les bandes",
        "outsideCornerMesh": "Angles sortants — Mesh enroulé 10 cm de chaque côté (+0,20 m²/ml)",
        "curvedSurfaceFactor": "Surface courbe — +15 % de déchets coating et mesh appliqué",
        "repairForfait": "Réparation — Quantités minimales forfaitaires appliquées"
      },
      "types": {
        "Wall": "Mur",
        "Pool": "Piscine",
        "Facade": "Façade",
        "Steps": "Escaliers",
        "Furniture": "Mobilier / Placard",
        "Room": "Pièce"
      },
      "typeDescriptions": {
        "Room": "Pièce avec sol, murs et plafond",
        "Wall": "Surface murale intérieure",
        "Pool": "Piscine ou bassin immergé",
        "Facade": "Façade extérieure",
        "Steps": "Escaliers ou nez de marche",
        "Furniture": "Mobilier, placard ou objet"
      },
      "roomSubtypes": {
        "Bathroom": "Salle de bain",
        "Default": "Standard"
      },
      "substrates": {
        "Tiles": "Carrelage",
        "Concrete": "Béton",
        "Wood": "Bois",
        "Brick": "Brique",
        "Block": "Parpaing",
        "Plasterboard": "Placo / cloison"
      },
      "finishes": {
        "Standard": "Standard",
        "Premium": "Premium"
      },
      "protectionLevels": {
        "None": "Aucune",
        "Presealer": "Présealer seul",
        "PresealerSealer": "Présealer + sealer acrylique",
        "PresealerHeavyDutySealer": "Présealer + sealer heavy duty"
      },
      "exposures": {
        "None": "Aucune",
        "Wet": "Humide (salle de bain — sans contact direct)",
        "DirectWater": "Contact direct eau (douche / vasque / bac)",
        "Submerged": "Immergé (piscine / fontaine)",
        "Outside": "Extérieur",
        "WaterProtected": "Protection eau (demande client)",
        "SolvantProtected": "Protection solvant Heavy-Duty"
      },
      "conditions": {
        "New": "Neuf",
        "Good": "Bon état",
        "Normal": "Normal",
        "Deteriorated": "Dégradé (Prep requis)"
      },
      "trafficLevels": {
        "None": "Aucun",
        "Low": "Faible",
        "Medium": "Moyen",
        "High": "Élevé"
      },
      "typeChangeReset": "Certains champs ont été réinitialisés car ils ne sont pas compatibles avec ce type de section.",
      "underfloorHeating": "Chauffage au sol",
      "underfloorHeatingPlaceholder": "Non renseigné",
      "underfloorHeatingYes": "Oui — chauffage au sol présent",
      "underfloorHeatingNo": "Non — pas de chauffage au sol",
      "underfloorHeatingType": "Type de chauffage",
      "underfloorHeatingUnknown": "Type inconnu",
      "underfloorHeatingWater": "Eau chaude",
      "underfloorHeatingElectric": "Électrique",
      "isExteriorRoom": "Extérieur",
      "isExteriorRoomHint": "La pièce est exposée à l'extérieur",
      "isFurnishedRoom": "Pièce meublée",
      "isFurnishedRoomHint": "La pièce contient des meubles à protéger",
      "isOccupiedSite": "Chantier occupé",
      "isOccupiedSiteHint": "Le site est occupé pendant les travaux",
      "steps": {
        "identity": "Identité",
        "type": "Type",
        "parameters": "Paramètres",
        "validation": "Validation"
      },
      "identityTitle": "Identité de la section",
      "identitySubtitle": "Nommez cette section et associez une couleur Mas Maya.",
      "typeTitle": "Type de section",
      "typeSubtitle": "Quel type de surface souhaitez-vous configurer ?",
      "roomConfigTitle": "Configuration de la pièce",
      "roomConfigSubtitle": "Renseignez les dimensions et les surfaces à traiter.",
      "standardConfigSubtitle": "Renseignez les caractéristiques techniques de cette surface.",
      "summaryTitle": "Récapitulatif",
      "summarySubtitle": "Vérifiez les informations avant de créer la section.",
      "colorModes": {
        "SingleColor": "Couleur unique",
        "PerSurface": "Couleurs par surface"
      },
      "colorPerSurfaceHint": "Choisissez une couleur pour chaque surface dans l'étape Paramètres.",
      "subtypeLabel": "Sous-type de pièce",
      "subtypes": {
        "Default": {
          "label": "Standard",
          "description": "Pièce sans configuration particulière"
        },
        "Bathroom": {
          "label": "Salle de bain",
          "description": "Finition Premium + exposition DirectWater imposés"
        },
        "Kitchen": {
          "label": "Cuisine",
          "description": "Bientôt disponible"
        },
        "Bedroom": {
          "label": "Chambre",
          "description": "Bientôt disponible"
        },
        "SpaHammam": {
          "label": "Spa / Hammam",
          "description": "Bientôt disponible"
        }
      },
      "comingSoon": "Bientôt disponible",
      "floorColorLabel": "Couleur sol",
      "wallsColorLabel": "Couleur murs",
      "ceilingColorLabel": "Couleur plafond",
      "createSection": "Créer la section",
      "selectColorPlaceholder": "Choisir une couleur…",
      "labelPlaceholderRoom": "ex. Salon principal, Salle de bain étage…",
      "surfacesToTreat": "Surfaces à traiter",
      "siteCharacteristics": "Caractéristiques du chantier",
      "createdTitle": "Section créée"
    },
    "consumption": {
      "title": "Consommation produits",
      "projectTotal": "Récapitulatif projet",
      "perSection": "Détail par section"
    },
    "materials": {
      "title": "Commande matériaux",
      "projectTotal": "Bon de commande",
      "perSection": "Détail par section",
      "product": "Produit",
      "qty": "Qté",
      "cost": "Coût",
      "noProducts": "Aucun produit à afficher",
      "noSections": "Aucune section pour l'instant — ajoutez une section dans l'onglet Sections pour voir les besoins en matériaux.",
      "productNotFound": "Aucun produit correspondant dans le catalogue",
      "orderOnShopify": "Commander sur masmaya.com",
      "largeVolumeActive": "Accès grand volume actif",
      "largeVolumeActiveDesc": "les sacs de 300 kg et 1000 kg sont inclus. Si ce chantier n'accepte pas les livraisons palette, désactivez l'accès grand volume dans les paramètres du projet.",
      "limitedAccess": "Accès limité — seuls les petits conditionnements sont proposés.",
      "line": {
        "prep": "Mas Maya Prep",
        "poolPrimer": "Mas Maya Pool Primer",
        "primer": "Mas Maya Primer",
        "coating1Layer": "Mas Maya Coating (1 couche)",
        "coating2Layer": "Mas Maya Coating (2 couches)",
        "mixingWater": "Eau de gâchage",
        "mesh": "Mas Maya Mesh",
        "presealer": "Mas Maya Presealer",
        "sealer": "Mas Maya Sealer",
        "heavyDutySealer": "Mas Maya Heavy-Duty Sealer",
        "waterproofMembrane": "Waterproof Membrane",
        "waterproofCornerReinforcement": "Waterproof Corner Reinforcement",
        "waterproofPipeReinforcement": "Waterproof Pipe Reinforcement",
        "pigment": "Pigment {{name}}"
      }
    },
    "quote": {
      "title": "Proposition commerciale",
      "breakdown": "Détail",
      "copyText": "Copier en texte",
      "copied": "Copié !",
      "materials": "Matériaux",
      "labour": "Main d'œuvre",
      "recipientEmail": "Email du destinataire",
      "downloadPdf": "Télécharger en PDF",
      "sendByEmail": "Envoyer par email",
      "provisionalDimensionsWarning": "Une ou plusieurs sections utilisent une hauteur de pièce provisoire (non confirmée). Les quantités et le coût affichés sont indicatifs — l'envoi par email et la création d'un devis Holded sont désactivés tant que la hauteur réelle n'a pas été renseignée dans la section.",
      "provisionalBadge": "Provisoire",
      "pdfError": "Erreur lors de la génération du PDF",
      "emailSuccess": "Proposition commerciale envoyée par email à {{email}}",
      "emailError": "Erreur lors de l'envoi de la proposition commerciale par email",
      "showPreview": "Voir la proposition commerciale",
      "client": "Client",
      "project": "Projet",
      "totalSurface": "Surface totale : {{surface}} m²",
      "sectionsProgress": "Sections : {{done}} / {{total}} terminées",
      "estimatedTime": "Temps estimé : {{hours}} h",
      "totalEstimated": "Total estimé",
      "disclaimer": "Cette proposition commerciale est indicative et établie à partir des éléments renseignés dans le projet ; elle est susceptible d'être ajustée après visite technique.",
      "sectionsHeading": "Détail par section",
      "whyTitle": "Pourquoi choisir Mas Maya ?",
      "whyIntro": "Spécialiste de l'étanchéité et des revêtements décoratifs pour piscines, salles d'eau et façades, Mas Maya conçoit des systèmes durables, esthétiques et faciles à entretenir.",
      "whyPoint1Title": "Réseau d'applicateurs certifiés",
      "whyPoint1Text": "Une pose garantie par des professionnels formés et certifiés Mas Maya, partout en France.",
      "whyPoint2Title": "Finitions premium",
      "whyPoint2Text": "Des rendus soignés et une large palette de couleurs, pensés pour durer dans le temps.",
      "whyPoint3Title": "Un accompagnement sur-mesure",
      "whyPoint3Text": "DIY, applicateur certifié ou réalisation clé en main par nos équipes : vous choisissez votre niveau d'accompagnement.",
      "addSectionToCart": "Ajouter au panier Mas Maya",
      "addProjectToCart": "Ajouter tout le projet au panier Mas Maya",
      "timeline": "Délais d'application",
      "totals": "Totaux projet",
      "rawHours": "Heures brutes",
      "adjustedHours": "Heures ajustées",
      "totalRawHours": "Total heures brutes",
      "totalHours": "Total heures (ajusté)",
      "noSections": "Aucune section avec des données à devis.",
      "textHeader": "DEVIS — {{name}}",
      "textSection": "Section",
      "complexityLevel": {
        "low": "Complexité faible",
        "normal": "Standard",
        "medium": "Complexité moyenne",
        "high": "Complexité élevée"
      },
      "tasks": {
        "prep": "Préparation",
        "primer": "Primer",
        "coating": "Application coating",
        "smoothing": "Lissage / polissage",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer"
      },
      "timelineSteps": {
        "afterPrep": "Après préparation",
        "afterPrimer": "Après primer",
        "betweenLayers": "Entre les couches",
        "afterSmoothing": "Après lissage",
        "afterPresealer": "Après presealer",
        "afterSealer": "Après sealer",
        "afterHeavyDutySealer": "Après Heavy-Duty Sealer",
        "poolFill": "Avant mise en eau"
      }
    },
    "workflow": {
      "title": "Statut des travaux",
      "notes": "Notes",
      "notesPlaceholder": "Ajouter une note...",
      "photos": "Photos",
      "addPhotos": "Ajouter des photos",
      "photoRequired": "Au moins une photo est requise",
      "history": "Historique",
      "approved": "Qualité approuvée",
      "status": {
        "InProgress": "En cours",
        "WorkerDone": "Travaux terminés",
        "QualityApproved": "Approuvé"
      },
      "changeType": {
        "WorkerDone": "Travaux terminés",
        "QualityApproved": "Approuvé",
        "QualitySkipped": "Contrôle ignoré",
        "QualityRejected": "Rejeté"
      },
      "workerDone": {
        "title": "Marquer comme terminé",
        "description": "Ajoutez au moins une photo pour confirmer la fin des travaux.",
        "action": "Marquer terminé",
        "submit": "Confirmer la fin"
      },
      "quality": {
        "title": "Contrôle qualité",
        "description": "Contrôlez la section et approuvez ou rejetez les travaux.",
        "action": "Contrôle qualité",
        "approve": "Approuver",
        "reject": "Rejeter",
        "skipCheck": "Ignorer le contrôle qualité (pas d'inspection nécessaire)"
      }
    },
    "cards": {
      "sections": "{{done}} / {{total}} sections approuvées",
      "totalProject": "Total projet",
      "labour": "Main d'œuvre",
      "materials": "Matériaux",
      "incompleteCalc": "Calcul incomplet",
      "materialsShort": "Mat.",
      "labourShort": "MO"
    },
    "sectionAttrs": {
      "characteristics": "Caractéristiques",
      "conditions": "Conditions d'utilisation",
      "dimensions": "Superficie et géométrie",
      "roomDimensions": "Dimensions de la pièce",
      "conditionsStandard": "Conditions standard",
      "color": "Couleur",
      "noColor": "Aucune couleur définie",
      "surfaceComputed": "Surface calculée",
      "surfaceComputedHint": "sera mise à jour après enregistrement",
      "surfaceUsed": "Surface utilisée",
      "surfaceOverridden": "Surface surchargée",
      "surfaceOverride": "Surcharge manuelle",
      "surfaceOverrideHint": "Laisser vide pour utiliser la surface calculée",
      "surfaceOverridePlaceholder": "Surface en m²",
      "noDimensions": "Dimensions non renseignées",
      "roomWidth": "Largeur",
      "roomLength": "Longueur",
      "roomHeight": "Hauteur",
      "coatWalls": "Enduire les murs",
      "coatCeiling": "Enduire le plafond",
      "coatFloor": "Enduire le sol",
      "parameters": "Paramètres",
      "siteOccupied": "Site occupé",
      "furnishedRoom": "Pièce meublée",
      "complexityLabel": "complexité",
      "furnishedMarkupLabel": "meublée",
      "occupiedMarkupLabel": "occupé",
      "standardFinishDiscountLabel": "finition standard",
      "editColorsHint": "Modifier les couleurs dans Paramètres ci-dessous",
      "coatingSurfaceSuffix": "m² à enduire"
    },
    "bulkColor": {
      "title": "Appliquer une couleur à toutes les sections",
      "hint": "La couleur sélectionnée sera appliquée aux {{count}} section(s) du projet.",
      "removeAll": "Retirer la couleur de toutes les sections",
      "confirmTitle": "Confirmer l'application",
      "confirmApply": "Appliquer la couleur « {{color}} » aux {{count}} section(s) ?",
      "confirmRemove": "Retirer la couleur de toutes les {{count}} section(s) ?",
      "appliedMessage": "Couleur appliquée aux sections sélectionnées.",
      "removedMessage": "Couleur retirée des sections sélectionnées."
    },
    "bulkFinishProtection": {
      "title": "Finition et protection (tout le projet)",
      "hint": "Ces réglages s'appliquent toujours à l'intégralité du projet — la consommation de matériaux et le coût de main d'œuvre en dépendent.",
      "finishLabel": "Finition",
      "protectionLabel": "Protection",
      "apply": "Appliquer à tout le projet",
      "confirmTitle": "Confirmer l'application",
      "confirmApplyFinish": "Finition « {{finish}} » sur {{count}} section(s).",
      "confirmApplyProtection": "Protection « {{level}} » sur {{count}} section(s).",
      "appliedMessage": "Finition et protection appliquées à l'ensemble du projet."
    },
    "bulkFinish": {
      "title": "Appliquer une finition à tout le projet",
      "hint": "Ceci change la finition pour toutes les sections du projet — la consommation de matériaux diffère selon la finition.",
      "lockedSectionsHint": "{{count}} section(s) avec une finition verrouillée (ex. escaliers, toujours en Premium) ne seront pas affectée(s).",
      "confirmCheckboxLabel": "Je comprends que cela s'applique à l'intégralité du projet",
      "apply": "Appliquer à tout le projet",
      "confirmTitle": "Confirmer l'application",
      "confirmApply": "Appliquer la finition « {{finish}} » aux {{count}} section(s) du projet ?",
      "appliedMessage": "Finition appliquée à l'ensemble du projet."
    },
    "bulkProtection": {
      "title": "Appliquer une protection à tout le projet",
      "hint": "Ceci change le niveau de protection (présealer / sealer) pour toutes les sections éligibles du projet — cela influe sur le prix des matériaux et sur le coût de main d'œuvre.",
      "lockedSectionsHint": "{{count}} section(s) (piscines ou zones en contact direct/immergé avec l'eau) conservent toujours leur protection obligatoire et ne seront pas affectée(s). Les sols des pièces restent aussi toujours automatiques.",
      "confirmCheckboxLabel": "Je comprends que cela s'applique à l'intégralité du projet",
      "apply": "Appliquer à tout le projet",
      "confirmTitle": "Confirmer l'application",
      "confirmApply": "Appliquer la protection « {{level}} » aux {{count}} section(s) du projet ?",
      "appliedMessage": "Protection appliquée à l'ensemble du projet."
    },
    "bulkType": {
      "title": "Appliquer un type à toutes les sections",
      "hint": "Le type sélectionné sera appliqué aux {{count}} section(s) de l'étage.",
      "confirmTitle": "Confirmer l'application",
      "confirmApply": "Appliquer le type « {{type}} » aux {{count}} section(s) ?",
      "coatingStep": "Surfaces à enduire",
      "descriptions": {
        "Room": "Pièce avec sol, murs et plafond",
        "Wall": "Surface murale intérieure",
        "Pool": "Piscine ou bassin immergé",
        "Facade": "Façade extérieure",
        "Steps": "Escaliers ou nez de marche",
        "Furniture": "Mobilier, placard ou objet"
      }
    },
    "bulkExclude": {
      "title": "Exclure des sections du calcul",
      "hint": "Les sections cochées seront exclues du calcul des matériaux et de la main d'œuvre.",
      "apply": "Appliquer",
      "selectAll": "Tout cocher",
      "selectNone": "Tout décocher",
      "banner": "{{count}} section(s) exclue(s) du calcul"
    },
    "extractPlan": {
      "title": "Extraire depuis un plan",
      "hint": "Importez un plan d'architecture pour extraire automatiquement les pièces et leurs dimensions.",
      "dropZone": "Cliquer pour choisir un plan (JPG, PNG, PDF...)",
      "extract": "Analyser le plan",
      "noPlans": "Aucun plan importé. Ajoutez des images ou un PDF ci-dessus.",
      "uploading": "Téléchargement en cours...",
      "partialError": "{{count}} page(s) n'ont pas pu être analysées.",
      "noRoomsFound": "Aucune pièce détectée. Essayez avec une image plus lisible.",
      "converting": "Conversion du PDF...",
      "extracting": "Analyse en cours...",
      "error": "Échec de l'analyse. Vérifiez que l'image est lisible et réessayez.",
      "selectHint": "{{count}} pièces détectées. Sélectionnez celles à transformer en sections.",
      "confidence": "score de confiance",
      "heightHint": "Hauteur visible sur le plan ou à renseigner manuellement",
      "applyHeightToAll": "Hauteur pour toutes les pièces",
      "createSections": "Créer {{count}} section(s)",
      "creating": "Création des sections en cours...",
      "generatingTasks": "Génération des tâches de suivi...",
      "done": "{{count}} section(s) créées avec succès !",
      "tasksGenerated": "{{count}} tâche(s) de suivi générée(s).",
      "surfaceType": "Quel type de surface souhaitez-vous configurer ?"
    },
    "tasks": {
      "form": {
        "title": "Titre",
        "titlePlaceholder": "Titre de la tâche",
        "category": "Catégorie",
        "priority": "Priorité",
        "plannedStart": "Date de début planifiée",
        "plannedEnd": "Date de fin planifiée",
        "datePlaceholder": "Choisir une date",
        "tabDescription": "Description",
        "tabTechnical": "Note technique",
        "tabInternal": "Note interne",
        "tabClient": "Note client",
        "descriptionPlaceholder": "Description de la tâche...",
        "technicalPlaceholder": "Notes techniques...",
        "internalPlaceholder": "Notes internes (non visibles client)...",
        "clientPlaceholder": "Instructions client...",
        "validationRequired": "Validation requise",
        "weatherSensitive": "Sensible aux intempéries",
        "clientVisible": "Visible client",
        "internalOnly": "Interne seulement",
        "mandatoryPhoto": "Photos obligatoires",
        "minPhotos": "Min photos",
        "create": "Créer une tâche",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "generatedWarning": "Cette tâche a été générée automatiquement. Modifier ce formulaire marquera la tâche comme « modifiée manuellement ».",
        "rejectionTitle": "Objet du refus",
        "rejectionTitlePlaceholder": "Ex : Texture non conforme",
        "rejectionReason": "Motif détaillé",
        "rejectionReasonPlaceholder": "Ex : La zone gauche présente une différence de grain trop visible…",
        "confirmRejection": "Confirmer le refus",
        "validationNotes": "Notes de validation (optionnel)",
        "validationNotesPlaceholder": "Notes pour le dossier...",
        "blockingType": "Type de blocage",
        "blockingTypeInternal": "Interne (matériel, planning, équipe…)",
        "blockingTypeExternal": "Externe (autre corps de métier, client, météo…)",
        "blockingReason": "Motif de blocage",
        "blockingReasonHint": "Expliquez ce qui doit se passer pour débloquer cette tâche — la personne qui lit doit savoir exactement quoi faire."
      },
      "source": {
        "Generated": "Générée",
        "Modified": "Modifiée",
        "Manual": "Manuelle"
      },
      "actions": {
        "title": "Actions",
        "start": "Démarrer la tâche",
        "requestReview": "Demander validation",
        "resubmit": "Soumettre à nouveau",
        "validate": "Valider la tâche",
        "reject": "Refuser la tâche",
        "unblock": "Débloquer la tâche",
        "block": "Bloquer la tâche",
        "addPhotos": "Ajouter des photos",
        "edit": "Modifier la tâche"
      },
      "status": {
        "Todo": "À faire",
        "Active": "En cours",
        "ReviewRequested": "En revue",
        "Completed": "Validée",
        "CorrectionRequired": "Correction requise",
        "Blocked": "Bloquée",
        "todoMessage": "Cette tâche n’est pas encore active. Elle démarrera automatiquement à la validation de la tâche précédente.",
        "awaitingValidation": "En attente de validation par le responsable.",
        "blockedLabel": "Bloquée",
        "blockedWhoInternal": "{{name}} doit agir pour débloquer cette tâche",
        "blockedWhoInternalFallback": "Votre équipe",
        "blockedWhoExternal": "En attente d'une action externe (client, fournisseur, autre corps de métier)",
        "completedLabel": "Tâche validée",
        "correctionRequired": "Tâche refusée",
        "instructions": "Instructions : {{instructions}}",
        "submittedPhotos": "Photos soumises",
        "requestReviewTitle": "Ajoutez au moins {{count}} photo(s) avant de demander la validation",
        "resubmitTitle": "Ajoutez au moins {{count}} photo(s) avant de soumettre à nouveau"
      },
      "photos": {
        "title": "Photos",
        "required": "· {{current}}/{{required}} requise(s)",
        "added": "Photo ajoutée",
        "uploadFailed": "Échec de l’upload photo",
        "uploadFailedMessage": "Impossible d’envoyer le fichier. Vérifiez le format ou réessayez."
      },
      "notifications": {
        "validated": "Tâche validée",
        "nextTaskStarted": "La tâche suivante a démarré automatiquement.",
        "lastTaskValidated": "Dernière tâche validée.",
        "validationError": "Erreur",
        "validationErrorMessage": "Impossible de valider la tâche.",
        "rejected": "Tâche refusée",
        "rejectedMessage": "Le travailleur a été notifié et peut corriger.",
        "rejectionError": "Erreur",
        "rejectionErrorMessage": "Impossible de refuser la tâche."
      },
      "history": "Historique",
      "deleteTask": {
        "title": "Supprimer la tâche",
        "confirm": "Êtes-vous sûr de vouloir supprimer <strong>{{name}}</strong> ?",
        "action": "Supprimer"
      },
      "editModal": "Modifier la tâche",
      "noTasksForStep": "Aucune tâche pour cette étape.",
      "noTasksForSection": "Aucune tâche générée pour cette section.",
      "blockedMessage_one": "Complétez {{count}} champ technique pour générer le flux de travail : {{fields}}.",
      "blockedMessage_other": "Complétez {{count}} champs techniques pour générer le flux de travail : {{fields}}.",
      "blockerField": {
        "height": "hauteur",
        "substrate": "support",
        "waterproofMembrane": "membrane d'étanchéité"
      },
      "completeConfiguration": "Compléter la configuration de la section",
      "readyToGenerate": "Cette section est prête — le flux de travail n'a pas encore été généré.",
      "generateNow": "Générer les tâches maintenant",
      "ungrouped": "Tâches sans étape",
      "taskCount_one": "{{count}} tâche",
      "taskCount_other": "{{count}} tâches",
      "completedCount_one": "{{count}} validée",
      "completedCount_other": "{{count}} validées",
      "blockedCount_one": "{{count}} bloquée",
      "blockedCount_other": "{{count}} bloquées",
      "deleteSectionTasks": {
        "title": "Supprimer toutes les tâches de la section",
        "confirm": "Supprimer les {{count}} tâche(s) de la section <strong>{{section}}</strong> ? Cette action est irréversible.",
        "action": "Tout supprimer",
        "tooltip": "Supprimer toutes les tâches de cette section"
      },
      "showPast_one": "Afficher {{count}} tâche passée",
      "showPast_other": "Afficher {{count}} tâches passées",
      "showFuture_one": "Afficher {{count}} tâche suivante",
      "showFuture_other": "Afficher {{count}} tâches suivantes",
      "hidePast": "Masquer les tâches passées",
      "hideFuture": "Masquer les tâches suivantes",
      "dateFrom": "À partir du {{date}}",
      "dateBefore": "Avant le {{date}}",
      "stepTypes": {
        "SubstratePreparation": "Préparation du support",
        "PrimerApplication": "Application du primer",
        "BaseLayer": "Couche de base",
        "MeshInstallation": "Pose de l’armature",
        "FinishingCoat": "Couche de finition",
        "Smoothing": "Lissage",
        "Presealer": "Présealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Sealer HD",
        "CuringStep": "Cure",
        "ProtectionPeriod": "Période de protection",
        "Handover": "Remise au client"
      },
      "sectionTypes": {
        "Wall": "Mur",
        "Floor": "Sol",
        "Bathroom": "Salle de bain",
        "Pool": "Piscine",
        "Facade": "Façade",
        "Steps": "Escaliers",
        "Furniture": "Mobilier",
        "Room": "Pièce",
        "Ceiling": "Plafond"
      },
      "categories": {
        "preparation": "Préparation",
        "primer": "Primer",
        "mesh": "Armature",
        "base_layer": "Couche de base",
        "finishing_layer": "Couche de finition",
        "smoothing": "Lissage",
        "presealer": "Présealer",
        "sealer": "Sealer",
        "heavy_duty_sealer": "Sealer HD",
        "curing": "Cure",
        "delivery": "Livraison",
        "inspection": "Inspection",
        "handover": "Remise",
        "custom": "Personnalisé"
      },
      "priorities": {
        "low": "Faible",
        "normal": "Normal",
        "high": "Élevée",
        "critical": "Critique"
      },
      "visualStatus": {
        "pending": "À faire",
        "inProgress": "En cours",
        "review": "En révision",
        "completed": "Validé",
        "rejected": "Rejeté",
        "blocked": "Bloqué",
        "overdue": "En retard"
      },
      "blockingType": {
        "Internal": "Interne",
        "External": "Externe"
      },
      "noSectionsMessage": "Créez une section pour générer automatiquement le suivi du projet.",
      "noTasksGeneratedMessage": "Aucune tâche générée. Vérifiez les données techniques de vos sections."
    },
    "projectType": {
      "Renovation": "Projet de rénovation",
      "RenovationDescription": "Réhabilitation de surfaces existantes",
      "Neuf": "Projet neuf",
      "NeufDescription": "Construction et surfaces neuves"
    },
    "sectionSource": {
      "import": "Importer des plans",
      "importDescription": "Détection automatique des pièces depuis vos plans architecturaux",
      "manual": "Créer manuellement",
      "manualDescription": "Définissez vos sections une par une"
    },
    "wizard": {
      "steps": {
        "project": "Projet",
        "mode": "Mode",
        "type": "Type",
        "logistics": "Logistique"
      },
      "step1": {
        "title": "Nouveau projet",
        "subtitle": "Renseignez les informations de base pour créer votre projet."
      },
      "step2": {
        "title": "Mode d'exécution",
        "subtitle": "Comment ce projet sera-t-il exécuté ?"
      },
      "step3": {
        "title": "Type de projet",
        "subtitle": "Quel est le contexte de ce chantier ?"
      },
      "step4": {
        "title": "Accès chantier",
        "subtitle": "Les grandes livraisons palette sont-elles possibles sur ce chantier ?"
      },
      "modes": {
        "ExternalOnly": {
          "label": "Projet DIY",
          "description": "Le client pilote l'exécution avec les informations fournies."
        },
        "MasMayaManaged": {
          "label": "Applicateur certifié",
          "description": "Projet confié à un applicateur certifié Mas Maya."
        },
        "MasMayaExecuted": {
          "label": "Mas Maya Executed",
          "description": "Projet exécuté directement par les équipes Mas Maya."
        }
      },
      "types": {
        "Renovation": {
          "label": "Rénovation",
          "description": "Support existant, état à qualifier."
        },
        "Neuf": {
          "label": "Projet neuf",
          "description": "Support neuf, paramètres préremplis."
        }
      },
      "access": {
        "large": {
          "label": "Accès grand volume",
          "description": "Livraisons palette, contenants 300 kg et 1000 kg possibles.",
          "hint": "Accès chantier compatible avec les grands volumes et livraisons palette.",
          "selectLabel": "Oui — livraisons palette possibles"
        },
        "limited": {
          "label": "Accès limité",
          "description": "Immeuble, étage, pas de monte-charge — petits conditionnements uniquement.",
          "hint": "Accès limité : les grands conditionnements seront désactivés automatiquement.",
          "selectLabel": "Non — accès limité, petits conditionnements uniquement"
        },
        "fieldLabel": "Accès chantier grand volume"
      }
    },
    "milestones": {
      "tabTitle": "Suivi",
      "empty": "Aucun jalon pour l'instant — ils sont générés automatiquement au fil des sections et validations du projet.",
      "templates": {
        "project_started": "Projet démarré",
        "preparation_completed": "Préparation terminée",
        "surface_approval": "Approbation de la surface",
        "surface_approval_desc": "Votre surface est prête avant protection finale. Merci de valider l'aspect avant application du système de protection.",
        "protection_completed": "Protection terminée",
        "delivery": "Livraison",
        "custom": "Nouveau milestone"
      },
      "status": {
        "Pending": "En attente",
        "AwaitingClient": "Approbation client requise",
        "Approved": "Approuvé",
        "Completed": "Terminé",
        "Rejected": "Modification demandée"
      },
      "approve": "Approuver",
      "reject": "Demander une modification",
      "rejectComment": "Commentaire (optionnel)",
      "confirmReject": "Confirmer la demande",
      "approvedByOn": "Approuvé par {{name}} le {{date}}",
      "approvalStale": "Cette section a été modifiée après la validation du client — la validation pourrait ne plus refléter son état actuel.",
      "clientApproval": {
        "title": "Validation de surface",
        "description": "Votre surface est prête avant protection finale. Merci de valider l'aspect avant application du système de protection."
      },
      "payment": {
        "NotDue": "Non dû",
        "Due": "À payer",
        "Paid": "Payé",
        "markPaid": "Marquer comme payé"
      }
    },
    "holded": {
      "createEstimate": "Créer un devis sur Holded",
      "modalDescription": "Choisissez ce que doit contenir le devis \"{{name}}\".",
      "creating": "Création en cours...",
      "success": "Devis créé sur Holded (ID: {{id}})",
      "error": "Erreur lors de la création du devis Holded"
    },
    "header": {
      "totalCoatingSurfaceTooltip": "Surface totale à enduire",
      "totalCoatingSurface": "{{value}} m² à enduire"
    },
    "filters": {
      "allManagers": "Tous les chefs de projet",
      "allExecutionModes": "Tous les modes d'exécution",
      "lateOnly": "En retard uniquement",
      "sortBy": "Trier par",
      "sort": {
        "manual": "Ordre manuel",
        "name": "Nom (A–Z)",
        "deadline": "Échéance, la plus proche",
        "surface": "Surface, la plus grande",
        "progress": "Progression",
        "total": "Valeur totale"
      },
      "clearAll": "Effacer les filtres"
    },
    "kpi": {
      "total": "Total projets",
      "createdThisMonth_one": "+{{count}} ce mois-ci",
      "createdThisMonth_other": "+{{count}} ce mois-ci",
      "shareOfBook": "{{pct}} % du portefeuille",
      "clickToIsolate": "Cliquer pour isoler",
      "unassignedPm_one": "{{count}} sans chef de projet",
      "unassignedPm_other": "{{count}} sans chef de projet",
      "portfolioValue": "Valeur du portefeuille",
      "pricingLoading": "Calcul en cours…",
      "incompleteCalc_one": "{{count}} calcul incomplet",
      "incompleteCalc_other": "{{count}} calculs incomplets",
      "upToDate": "Chiffrage complet",
      "avgProgress": "Progression moy.",
      "acrossActiveWork_one": "sur {{count}} projet",
      "acrossActiveWork_other": "sur {{count}} projets"
    },
    "list": {
      "surface": "Surface",
      "progress": "Progression",
      "total": "Total",
      "deadline": "Échéance",
      "lateBy_one": "retard {{count}}j",
      "lateBy_other": "retard {{count}}j",
      "unassigned": "Non assigné"
    },
    "bulk": {
      "selectedCount_one": "{{count}} sélectionné",
      "selectedCount_other": "{{count}} sélectionnés",
      "selectAll": "Tout sélectionner",
      "changeStatus": "Changer le statut",
      "assignPm": "Assigner un chef de projet",
      "changeExecutionMode": "Changer le mode d'exécution",
      "archive": "Archiver",
      "archiveTitle": "Archiver les projets",
      "archiveConfirm_one": "Archiver {{count}} projet ? Le statut pourra être changé à nouveau ensuite.",
      "archiveConfirm_other": "Archiver {{count}} projets ? Le statut pourra être changé à nouveau ensuite.",
      "clearSelection": "Effacer la sélection",
      "statusApplied_one": "{{count}} projet mis à jour",
      "statusApplied_other": "{{count}} projets mis à jour",
      "pmApplied_one": "{{count}} projet mis à jour",
      "pmApplied_other": "{{count}} projets mis à jour",
      "executionModeApplied_one": "{{count}} projet mis à jour",
      "executionModeApplied_other": "{{count}} projets mis à jour",
      "partialFailure": "{{succeeded}} mis à jour, {{failed}} en échec"
    }
  },
  "contacts": {
    "title": "Contacts",
    "createButton": "Nouveau contact",
    "createTitle": "Créer un contact",
    "editTitle": "Modifier le contact",
    "searchPlaceholder": "Rechercher par nom, société, email ou téléphone...",
    "allTypes": "Tous les types",
    "noData": "Aucun contact trouvé",
    "columns": {
      "name": "Nom",
      "type": "Type",
      "email": "Email",
      "phone": "Téléphone",
      "entity": "Entité"
    },
    "type": {
      "Individual": "Particulier",
      "Company": "Société"
    },
    "status": {
      "active": "Actif",
      "inactive": "Archivé"
    },
    "sections": {
      "general": "Informations générales",
      "contact": "Coordonnées",
      "projects": "Projets associés",
      "enrollments": "Sessions de cours",
      "training": "Formation & Certifications"
    },
    "form": {
      "entity": "Entité",
      "entityRequired": "L'entité est requise",
      "type": "Type",
      "displayName": "Nom affiché",
      "displayNameRequired": "Le nom affiché est requis",
      "firstName": "Prénom",
      "lastName": "Nom",
      "companyName": "Raison sociale",
      "email": "Email",
      "phone": "Téléphone",
      "addressLine1": "Adresse",
      "addressLine2": "Adresse (ligne 2)",
      "postalCode": "Code postal",
      "city": "Ville",
      "country": "Pays (ISO Alpha-2)",
      "notes": "Notes"
    },
    "archive": {
      "title": "Archiver le contact",
      "confirm": "Êtes-vous sûr de vouloir archiver \"{{name}}\" ? Il ne sera plus visible par défaut.",
      "action": "Archiver"
    },
    "projectColumns": {
      "name": "Projet",
      "status": "Statut"
    },
    "enrollmentColumns": {
      "course": "Cours",
      "date": "Date",
      "teacher": "Formateur",
      "status": "Statut"
    },
    "discount": {
      "sectionTitle": "Remise & Certification",
      "permanentDiscount": "Remise permanente",
      "baseDiscount": "Remise de base",
      "manualOverride": "Remise manuelle",
      "manualOverrideHint": "Remise admin (10%–35% par paliers de 2,5%). S'applique si supérieure à la remise formation.",
      "linkedStudent": "ID étudiant lié",
      "linkedStudentHint": "Lier un dossier étudiant pour activer les remises par certification",
      "linked": "Lié"
    },
    "installer": {
      "sectionTitle": "Installateur référencé",
      "badge": "Installateur référencé",
      "status": "Statut installateur",
      "active": "Actif",
      "inactive": "Non référencé",
      "enable": "Activer la référence",
      "disable": "Retirer la référence",
      "requirement": "Certification",
      "certificationLinked": "Étudiant lié",
      "certificationRequired": "Aucun étudiant lié — certification requise"
    },
    "hierarchy": {
      "linkedContacts": "Contacts liés",
      "noLinkedContacts": "Aucun contact individuel lié.",
      "parentCompany": "Société parente",
      "noParentCompany": "Aucune société parente liée.",
      "link": "Lier",
      "unlink": "Délier",
      "unlinkTitle": "Délier le contact",
      "unlinkConfirm": "Délier \"{{name}}\" de cette société ?",
      "unlinkParentConfirm": "Retirer le lien avec \"{{name}}\" ?",
      "linkToCompany": "Lier à une société",
      "selectIndividual": "Sélectionner un contact individuel...",
      "selectCompany": "Sélectionner une société..."
    },
    "professional": {
      "sectionTitle": "Informations professionnelles",
      "siren": "SIREN",
      "sirenRequired": "Le SIREN est requis",
      "sirenFormat": "Le SIREN doit comporter exactement 9 chiffres",
      "sirenNotFound": "Aucune entreprise trouvée pour ce SIREN",
      "vatNumber": "Numéro de TVA",
      "vatRequired": "Le numéro de TVA est requis",
      "companyNameHint": "Nom utilisé par votre contact (peut différer de la dénomination légale)",
      "companyNameRequired": "Le nom de l'entreprise est requis",
      "legalName": "Dénomination légale",
      "registeredAddress": "Siège social",
      "companyStatus": "Statut de l'entreprise",
      "statusRadiated": "Radiée",
      "director": "Dirigeant",
      "activity": "Activité"
    }
  },
  "colors": {
    "title": "Sélecteur de couleur",
    "colorCount": "couleurs",
    "importButton": "Importer la matrice CSV",
    "exportButton": "Exporter la matrice CSV",
    "importSuccess": "Importation réussie",
    "importSuccessCount": "{{count}} couleurs importées.",
    "noData": "Aucune formule de couleur chargée. Importez une matrice CSV pour commencer.",
    "noCollection": "Autres",
    "weight": "Poids (kg)",
    "weightHint": "Les quantités de pigments s'ajustent au poids",
    "coating": "Base de revêtement",
    "pigments": "Pigments",
    "productNotFound": "Produit introuvable dans le catalogue",
    "needed": "nécessaire :",
    "unit": "unité",
    "subtotal": "Sous-total :",
    "grandTotal": "Total",
    "pickColor": "Choisir une couleur",
    "searchPlaceholder": "Rechercher une couleur...",
    "noResults": "Aucune couleur ne correspond à votre recherche",
    "removeColor": "Retirer la couleur"
  },
  "courses": {
    "enroll": {
      "search": "Rechercher un contact",
      "searchPlaceholder": "Rechercher par nom ou e-mail...",
      "contact": "Contact",
      "contactPlaceholder": "Sélectionner un contact...",
      "noResults": "Aucun contact trouvé",
      "action": "Inscrire"
    }
  },
  "teachers": {
    "title": "Professeurs certifiés",
    "createButton": "Nouveau professeur",
    "createTitle": "Ajouter un professeur",
    "editTitle": "Modifier le professeur",
    "backToList": "Retour aux professeurs",
    "searchPlaceholder": "Rechercher par nom, email ou pays...",
    "allStatuses": "Tous les statuts",
    "noData": "Aucun professeur trouvé",
    "inactive": "Inactif",
    "noCertifiedLevels": "Aucun niveau certifié",
    "columns": {
      "name": "Nom",
      "certification": "Certification",
      "levels": "Niveaux certifiés",
      "languages": "Langues",
      "validity": "Valide jusqu'au"
    },
    "certificationStatus": {
      "Pending": "En attente",
      "Active": "Actif",
      "Expired": "Expiré",
      "Revoked": "Révoqué"
    },
    "form": {
      "fullName": "Nom complet",
      "fullNameRequired": "Le nom est requis",
      "email": "Email",
      "emailRequired": "L'email est requis",
      "country": "Pays (ISO Alpha-2)",
      "languages": "Langues",
      "certifiedLevels": "Niveaux certifiés",
      "specialties": "Spécialités",
      "specialtiesPlaceholder": "Piscine, Extérieur...",
      "isActive": "Professeur actif"
    },
    "certify": {
      "title": "Certifier le professeur",
      "action": "Certifier",
      "levels": "Niveaux à certifier",
      "levelsRequired": "Sélectionnez au moins un niveau",
      "certificationDate": "Date de certification",
      "expirationDate": "Date d'expiration",
      "expirationRequired": "La date d'expiration est requise",
      "selfCertifyNote": "Un professeur ne peut pas s'auto-certifier. Cette action est réservée aux administrateurs Mas Maya.",
      "expired": "Certification expirée"
    },
    "revoke": {
      "title": "Révoquer la certification",
      "confirm": "Révoquer la certification de ce professeur ? Il ne pourra plus enseigner de sessions.",
      "action": "Révoquer"
    },
    "info": {
      "certification": "Certification",
      "profile": "Profil",
      "certifiedOn": "Certifié le",
      "expiresOn": "Expire le"
    },
    "sessions": {
      "title": "Sessions assignées",
      "empty": "Aucune session assignée"
    },
    "evaluations": {
      "title": "Évaluations des élèves",
      "student": "Élève",
      "score": "Note",
      "notes": "Commentaires",
      "date": "Date"
    },
    "evaluate": {
      "title": "Évaluer un élève",
      "addButton": "Ajouter une évaluation",
      "action": "Soumettre",
      "student": "Élève",
      "studentPlaceholder": "Sélectionner un élève...",
      "noStudents": "Aucun élève trouvé",
      "score": "Note (1–5)",
      "scoreHint": "1 = à améliorer, 5 = excellent",
      "notes": "Commentaires"
    }
  },
  "students": {
    "title": "Élèves",
    "createButton": "Nouvel élève",
    "createTitle": "Ajouter un élève",
    "searchPlaceholder": "Rechercher par nom ou email...",
    "noData": "Aucun élève trouvé",
    "type": {
      "Individual": "Particulier",
      "Professional": "Professionnel"
    },
    "columns": {
      "name": "Nom",
      "email": "Email",
      "type": "Type",
      "company": "Entreprise",
      "country": "Pays",
      "language": "Langue"
    },
    "form": {
      "firstName": "Prénom",
      "firstNameRequired": "Le prénom est requis",
      "lastName": "Nom",
      "lastNameRequired": "Le nom est requis",
      "email": "Email",
      "emailRequired": "L'email est requis",
      "phone": "Téléphone",
      "type": "Type",
      "companyName": "Nom de l'entreprise"
    }
  },
  "certifications": {
    "title": "Certifications Applicateur",
    "allLevels": "Tous les niveaux",
    "allStatuses": "Tous les statuts",
    "searchPlaceholder": "Rechercher par nom ou email...",
    "noData": "Aucune certification trouvée",
    "viewLevels": "Voir les niveaux",
    "publicPage": "Page publique",
    "status": {
      "Pending": "En attente",
      "Passed": "Validée",
      "Failed": "Échouée",
      "Expired": "Expirée"
    },
    "columns": {
      "student": "Élève",
      "level": "Niveau",
      "status": "Statut",
      "issuedAt": "Délivrée le",
      "expiration": "Expire le",
      "session": "Session",
      "finishes": "Finitions expert",
      "certifications": "Certifications"
    },
    "issue": {
      "title": "Délivrer une certification",
      "action": "Délivrer",
      "levelRequired": "Le niveau est requis",
      "level": "Niveau de certification",
      "issuedAt": "Date de délivrance",
      "expirationDate": "Date d'expiration",
      "notes": "Notes",
      "basicNote": "Les certifications Basic sont validées automatiquement après participation complète et ne peuvent pas être échouées.",
      "allLevelsIssued": "Cet élève a déjà une certification pour tous les niveaux.",
      "alreadyIssued": "Certification déjà délivrée pour ce niveau",
      "absentCannotIssue": "Impossible de délivrer une certification à un élève absent",
      "expertFinishes": "Finitions expert validées",
      "terrazzoMetadata": "Terrazzo — base + 3 couleurs d'incrustations",
      "terrazzoPlaceholder": "ex. Base blanc, noir, or, rouille"
    },
    "update": {
      "title": "Mettre à jour la certification",
      "action": "Enregistrer",
      "status": "Statut",
      "addFinish": "Valider une finition expert",
      "selectFinish": "Sélectionner une finition...",
      "validateFinish": "Valider la finition"
    },
    "levels": {
      "title": "Niveaux de Certification Applicateur",
      "subtitle": "Compétences et périmètre d'application requis par niveau",
      "skills": "Périmètre d'application",
      "products": "Produits requis",
      "finishes": "Finitions créatives",
      "canFail": "Peut être échouée",
      "cannotFail": "Ne peut pas être échouée",
      "autoValidates": "Validation automatique"
    },
    "levelDefinitions": {
      "basic": {
        "title": "Applicateur Basic",
        "skills": {
          "interiorWalls": "Murs intérieurs",
          "interiorFloors": "Sols intérieurs",
          "interiorCeilings": "Plafonds intérieurs",
          "cleanStableSubstrates": "Supports propres et stables"
        }
      },
      "intermediate": {
        "title": "Applicateur Intermédiaire",
        "skills": {
          "protectedExteriors": "Extérieurs protégés",
          "complexInteriors": "Intérieurs complexes",
          "deterioratedSubstrates": "Supports détériorés",
          "correctivePrep": "Préparation corrective"
        }
      },
      "expert": {
        "title": "Applicateur Expert",
        "skills": {
          "wetRooms": "Pièces humides",
          "showers": "Douches",
          "bathtubs": "Baignoires",
          "pools": "Piscines",
          "fountains": "Fontaines",
          "facades": "Façades",
          "wetAreas": "Zones humides"
        }
      },
      "expertFinishes": {
        "title": "Applicateur Expert Finitions",
        "skills": {
          "advancedCreativeFinishes": "Finitions avancées et créatives"
        },
        "finishes": {
          "pise": "Pisé",
          "castConcreteAcetate": "Béton coulé acétate",
          "woodFormworkConcrete": "Béton coffrage bois",
          "burntEffect": "Effet brûlé",
          "brushedConcrete": "Béton brossé",
          "rawSandEffect": "Effet brut sable",
          "shouSugiBan": "Shou Sugi Ban",
          "naturalStoneEffect": "Effet pierre naturelle",
          "terrazzoEffect": "Effet terrazzo (base + 3 incrustations)"
        }
      },
      "products": {
        "preparation": "Préparation",
        "base": "Base"
      }
    },
    "public": {
      "subtitle": "{{count}} certification(s) validée(s)",
      "noData": "Aucune certification trouvée pour cet applicateur.",
      "footer": "Certifié par Mas Maya · masmaya.fr"
    },
    "admin": {
      "newDefinition": "Nouvelle définition",
      "editDefinition": "Modifier la définition",
      "noDefinitions": "Aucune définition.",
      "form": {
        "name": "Nom",
        "slug": "Slug",
        "slugDescription": "Identifiant URL unique (ex: basic-applicator)",
        "category": "Catégorie",
        "prerequisites": "Prérequis",
        "description": "Description",
        "sortOrder": "Ordre d'affichage",
        "isActive": "Active"
      },
      "columns": {
        "name": "Nom",
        "slug": "Slug",
        "category": "Catégorie",
        "prerequisites": "Prérequis",
        "order": "Ordre",
        "active": "Active"
      }
    }
  },
  "finishEvaluation": {
    "modalTitle": "Évaluation de finition Expert",
    "evaluateAction": "Évaluer une finition",
    "finishType": "Type de finition",
    "finishPlaceholder": "Sélectionner une finition...",
    "finishRequired": "Veuillez sélectionner un type de finition",
    "score": "Note (0–10)",
    "willFail": "En dessous du seuil de validation",
    "photos": "Photos",
    "photosBefore": "Photos avant",
    "photosDuring": "Photos en cours",
    "photosAfter": "Photos après",
    "dropPhotos": "Déposer des images ou cliquer pour parcourir",
    "photosRequired": "Au moins une photo avant et une photo après sont requises",
    "terrazzoColors": "Couleurs terrazzo",
    "terrazzoBase": "Couleur de base",
    "terrazzoColor1": "Incrustation 1",
    "terrazzoColor2": "Incrustation 2",
    "terrazzoColor3": "Incrustation 3",
    "terrazzoColorsRequired": "Les quatre couleurs terrazzo sont obligatoires",
    "submit": "Soumettre l'évaluation",
    "uploading": "Téléchargement des photos…",
    "historyTitle": "Évaluations des finitions Expert",
    "attempts": "{{count}} tentative(s)",
    "finishes": {
      "Pise": {
        "label": "Effet pisé",
        "description": "Compactage par couches successives imitant le pisé traditionnel."
      },
      "BetonCoule": {
        "label": "Béton coulé acétate",
        "description": "Coulage béton avec feuille d'acétate pour un effet lissé et brillant."
      },
      "BetonCoffrage": {
        "label": "Béton coffrage bois",
        "description": "Empreinte de planches de bois dans le béton pour texture structurée."
      },
      "EffetBrule": {
        "label": "Effet brûlé",
        "description": "Pierre extrêmement ferme ou plantoir inox pour créer une texture brûlée."
      },
      "BetonBrosse": {
        "label": "Béton brossé",
        "description": "Brossage du béton frais pour créer une surface texturée avec stries."
      },
      "EffetBrut": {
        "label": "Effet brut avec traces de sable",
        "description": "Finition brute laissant apparaître des traces de sable en surface."
      },
      "ShouSugiBan": {
        "label": "Bois brûlé Shou Sugi Ban",
        "description": "Technique japonaise de brûlage du bois par démoulage."
      },
      "EffetPierre": {
        "label": "Effet pierre naturelle",
        "description": "Imitation de la texture et du rendu d'une pierre naturelle."
      },
      "EffetTerrazzo": {
        "label": "Effet terrazzo",
        "description": "Terrazzo avec couleur de base et 3 incrustations colorées."
      }
    }
  },
  "certificates": {
    "title": "Certificats numériques",
    "status": {
      "Active": "Actif",
      "Expired": "Expiré",
      "Revoked": "Révoqué"
    },
    "verify": {
      "title": "Vérification de certificat",
      "code": "Code de vérification",
      "level": "Niveau de certification",
      "specialties": "Spécialités",
      "issued": "Émis le",
      "expires": "Expire le",
      "revokedOn": "Révoqué le",
      "validNote": "Ce certificat a été émis par Mas Maya et est vérifiable en ligne.",
      "notFound": "Certificat introuvable",
      "notFoundDesc": "Aucun certificat ne correspond à ce code de vérification.",
      "link": "Vérifier"
    },
    "revoke": {
      "title": "Révoquer le certificat",
      "confirm": "Êtes-vous sûr de vouloir révoquer ce certificat ? Cette action est irréversible.",
      "action": "Révoquer",
      "defaultReason": "Révoqué par l'administrateur"
    }
  },
  "evaluation": {
    "modalTitle": "Évaluation de certification",
    "evaluateCertification": "Évaluer la certification",
    "selectStudent": "Élève",
    "studentPlaceholder": "Sélectionner un élève...",
    "studentRequired": "Veuillez sélectionner un élève",
    "criteria": "Critères d'évaluation",
    "scoreRange": "Note 0–10",
    "finalScore": "Note globale",
    "willPass": "Validera",
    "willFail": "{{count}} critère(s) insuffisant(s)",
    "failAlert": "Les critères suivants sont en dessous du seuil : {{criteria}}",
    "teacherNotes": "Notes du professeur",
    "notesPlaceholder": "Observations, points d'amélioration...",
    "noCriteria": "Aucun critère défini pour ce niveau",
    "submit": "Soumettre l'évaluation",
    "history": "Historique des évaluations",
    "passed": "Validé",
    "failed": "Échoué",
    "failedCriteria": "Critères non validés",
    "retrySessions": "Sessions de rattrapage disponibles",
    "seats": "places"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "subtitle": "Vue d'ensemble de votre activité de formation",
    "upcomingSessions": "Prochaines sessions",
    "stats": {
      "students": "Élèves",
      "teachers": "Professeurs",
      "activeCerts": "Certifications actives",
      "pendingCerts": "En attente",
      "upcomingSessions": "À venir (30j)",
      "passedThisYear": "Certifiés cette année"
    },
    "projectsOverview": {
      "title": "Chantiers",
      "active": "En cours",
      "blocked": "Bloqués",
      "awaitingValidation": "En attente de validation",
      "late": "En retard",
      "needsAttention": "Nécessite votre attention"
    }
  },
  "teacherDashboard": {
    "welcomeLabel": "Bienvenue",
    "noProfile": "Aucun profil professeur",
    "noProfileDesc": "Aucun profil professeur n'est associé à votre compte.",
    "upcomingSessions": "Vos prochaines sessions",
    "recentEvaluations": "Évaluations récentes",
    "noSessions": "Aucune session assignée",
    "stats": {
      "upcoming": "À venir",
      "sessions": "Sessions totales",
      "evaluations": "Évaluations"
    }
  },
  "studentPortal": {
    "title": "Espace élève",
    "subtitle": "Accédez à vos résultats de formation, certifications et prochaines sessions.",
    "emailLabel": "Votre adresse e-mail",
    "emailPlaceholder": "eleve@exemple.fr",
    "lookup": "Accéder à mon profil",
    "notFound": "Aucun compte trouvé",
    "profileLabel": "Mon profil",
    "profileNotFound": "Profil introuvable",
    "upcomingSessions": "Prochaines sessions",
    "pastSessions": "Sessions passées",
    "footer": "Mas Maya Formation · masmaya.fr",
    "privacyNote": "Seules vos données de formation sont affichées. Aucun compte ni mot de passe requis."
  },
  "enroll": {
    "title": "S'inscrire à une session",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Adresse e-mail",
    "type": "Type",
    "company": "Entreprise / Organisation",
    "country": "Pays (code 2 lettres)",
    "language": "Langue préférée",
    "seatsLeft": "{{count}} place(s) disponible(s)",
    "submit": "S'inscrire",
    "requiredFields": "Veuillez remplir tous les champs obligatoires.",
    "notOpen": "Inscriptions non ouvertes",
    "notOpenDesc": "Cette session n'est pas actuellement ouverte aux inscriptions.",
    "sessionNotFound": "Session introuvable",
    "successTitle": "Inscription confirmée !",
    "successDesc": "Votre place est réservée. Vous recevrez une confirmation par e-mail.",
    "viewProfile": "Voir mon profil",
    "error": "Une erreur est survenue. Veuillez réessayer.",
    "privacyNote": "Vos données sont utilisées uniquement à des fins de formation.",
    "professional": {
      "siren": "Numéro SIREN",
      "sirenDesc": "9 chiffres — recherche automatique via Pappers",
      "sirenRequired": "Le numéro SIREN est requis (9 chiffres).",
      "sirenNotFound": "Entreprise introuvable ou SIREN invalide.",
      "vatNumber": "Numéro de TVA intracommunautaire",
      "vatRequired": "Le numéro de TVA est requis.",
      "companyRequired": "Le nom commercial est requis.",
      "companyNameDesc": "Nom utilisé au quotidien (peut différer du nom légal)",
      "director": "Dirigeant",
      "radiated": "Entreprise radiée / fermée"
    }
  },
  "entities": {
    "title": "Entités",
    "createButton": "Nouvelle entité",
    "createTitle": "Créer une entité",
    "editTitle": "Modifier l'entité",
    "searchPlaceholder": "Rechercher par nom, code ou pays...",
    "showArchived": "Afficher les archivées",
    "noData": "Aucune entité trouvée",
    "noUsers": "Aucun utilisateur assigné",
    "viewUsers": "Voir les utilisateurs",
    "columns": {
      "name": "Nom",
      "code": "Code",
      "country": "Pays",
      "status": "Statut",
      "users": "Utilisateurs"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "sections": {
      "general": "Informations générales",
      "users": "Utilisateurs assignés",
      "staff": "Membres de l'équipe"
    },
    "noStaff": "Aucun membre pour cette entité",
    "form": {
      "name": "Nom",
      "nameRequired": "Le nom est requis",
      "code": "Code interne",
      "codePlaceholder": "ex. CORP-FR",
      "country": "Pays (ISO Alpha-2)",
      "countryPlaceholder": "Sélectionner un pays",
      "countryRequired": "Le pays est requis",
      "currency": "Devise (ISO 4217)",
      "timezone": "Fuseau horaire",
      "email": "Email de contact",
      "logoUrl": "URL du logo",
      "isActive": "Actif"
    },
    "archive": {
      "title": "Archiver l'entité",
      "confirm": "Êtes-vous sûr de vouloir archiver \"{{name}}\" ? Elle ne sera plus visible par défaut.",
      "confirm_action": "Archiver"
    },
    "assignUser": {
      "title": "Assigner un utilisateur",
      "button": "Assigner un utilisateur",
      "searchLabel": "Rechercher un utilisateur",
      "searchPlaceholder": "Nom ou email...",
      "noResults": "Aucun utilisateur trouvé",
      "selected": "Sélectionné",
      "assign": "Assigner"
    },
    "removeUser": {
      "title": "Retirer l'utilisateur",
      "confirm": "Retirer {{name}} de cette entité ?"
    },
    "managers": {
      "title": "Responsables",
      "role": "Manager d'entité",
      "noAvailable": "Aucun utilisateur disponible"
    },
    "userColumns": {
      "name": "Nom",
      "email": "Email",
      "assignedOn": "Assigné le"
    },
    "quoteConfig": {
      "title": "Configuration devis",
      "subtitle": "Valeurs par défaut utilisées pour le calcul de consommation",
      "consumptionRates": "Taux de consommation",
      "wasteFactors": "Facteurs de perte",
      "labourRates": "Main d'œuvre",
      "complexityMultipliers": "Multiplicateurs de complexité",
      "fields": {
        "coating1LayerKgPerM2": "Coating 1 couche",
        "coating2LayerKgPerM2": "Coating 2 couches",
        "mixingWaterWallLPerKg": "Eau gâchage mur",
        "mixingWaterFloorLPerKg": "Eau gâchage sol",
        "prepCoverageM2Per10Kg": "Prep",
        "primerCoverageM2PerL": "Primer",
        "poolPrimerCoverageM2PerL": "Pool Primer",
        "presealerCoverageM2PerL": "Presealer",
        "sealerCoverageM2PerL": "Sealer",
        "heavyDutySealerCoverageM2PerL": "Heavy-Duty Sealer",
        "meshWasteFactor": "Perte mesh simple",
        "meshComplexWasteFactor": "Perte mesh complexe",
        "generalWasteFactor": "Perte générale",
        "labourRatePerM2": "Taux / m²",
        "labourRatePerSurface": "Taux / surface",
        "labourRatePerProduct": "Taux / produit",
        "complexityLow": "Faible",
        "complexityNormal": "Normal",
        "complexityMedium": "Moyen",
        "complexityHigh": "Élevé",
        "repairMinSurfaceM2": "Surface min. réparation (m²)",
        "prepMarginPercent": "Marge Prep",
        "primerMarginPercent": "Marge Primer",
        "poolPrimerMarginPercent": "Marge Pool Primer",
        "coatingMarginPercent": "Marge Coating",
        "meshMarginPercent": "Marge Mesh",
        "presealerMarginPercent": "Marge Presealer",
        "sealerMarginPercent": "Marge Sealer",
        "heavyDutySealerMarginPercent": "Marge HD Sealer",
        "pigmentMarginPercent": "Marge Pigments"
      },
      "siteLogistics": "Logistique chantier",
      "maxSmallAccessCoatingBag": "Maximum sac coating sans accès grand volume",
      "materialMargin": "Marges matériaux",
      "markups": {
        "title": "Majorations chantier",
        "occupiedSite": "Site occupé (%)",
        "furnishedRoom": "Pièce meublée (%)",
        "standardFinishDiscount": "Remise finition standard (%)",
        "standardFinishDiscountHint": "Les tarifs de main d'œuvre de base sont calibrés pour la finition Premium. Cette remise s'applique quand la finition d'une section est Standard."
      },
      "degressiveRates": "Tarifs dégressifs au m²",
      "addTier": "Ajouter un palier",
      "tierFields": {
        "minSurface": "Surface min.",
        "maxSurface": "Surface max.",
        "rate": "Tarif (€/m²)",
        "enabled": "Actif"
      }
    },
    "taskGenConfig": {
      "title": "Variables de génération de tâches",
      "save": "Sauvegarder les variables",
      "saveSuccess": "Variables de génération sauvegardées.",
      "saveError": "La sauvegarde a échoué.",
      "unsavedWarning": "Modifications non sauvegardées. Cliquez sur Sauvegarder pour appliquer aux futures générations.",
      "critical": "critique",
      "taskFamilies": {
        "title": "Activation des familles de tâches",
        "description": "Désactiver une famille empêche ces tâches d'être générées dans les nouveaux projets. Les tâches existantes ne sont pas supprimées.",
        "preparation": "Préparation du support",
        "primer": "Primaire",
        "mesh": "Mesh / treillis",
        "coating": "Couches de finition",
        "drying": "Temps de séchage",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDuty": "Heavy-Duty Sealer",
        "qualityControl": "Contrôle qualité",
        "aftercare": "Aftercare / protection",
        "handover": "Remise client (Handover)"
      },
      "substratePrep": {
        "title": "Préparation du support",
        "inspection": "Inspection substrate",
        "surfaceCleaning": "Nettoyage de surface",
        "sanding": "Ponçage",
        "dustRemoval": "Dépoussiérage",
        "maskingProtection": "Protection des zones adjacentes",
        "crackTreatment": "Traitement des fissures",
        "jointTreatment": "Traitement des joints",
        "maxImperfectionMm": "Imperfection max.",
        "maxImperfectionHint": "Seuil au-delà duquel une tâche de remplissage est générée"
      },
      "primer": {
        "title": "Primaire",
        "minWaitMinutes": "Attente min. primer standard",
        "minWaitHint": "Délai minimum avant application de la première couche",
        "maxWindowHours": "Fenêtre max. primer standard",
        "maxWindowHint": "La couche doit être appliquée avant cette durée",
        "poolMinWaitMinutes": "Attente min. primer piscine",
        "poolMinWaitHint": "Pool Primer — attente minimale avant coating"
      },
      "mixing": {
        "title": "Mélange et couches",
        "mixRestMinutes": "Repos du mélange",
        "mixRestHint": "Temps de repos après mélange avant application",
        "wallWaterRatio": "Ratio eau mur",
        "floorWaterRatio": "Ratio eau sol",
        "baseLayerThickness": "Épaisseur couche de base",
        "finishLayerThickness": "Épaisseur couche de finition"
      },
      "mesh": {
        "title": "Mesh / Treillis",
        "overlapCm": "Recouvrement mesh",
        "edgeDistanceCm": "Distance bord mesh",
        "requiredFor": "Mesh obligatoire pour",
        "floors": "Sols",
        "stairs": "Escaliers",
        "tiles": "Carrelage",
        "wood": "Bois",
        "pools": "Piscines",
        "bathrooms": "Salles de bain",
        "exteriors": "Façades / extérieur"
      },
      "waterproofing": {
        "title": "Étanchéité",
        "description": "L'enduit Mas Maya est résistant à l'eau mais non étanchéifiant. Une membrane d'étanchéité est requise dans les cas suivants.",
        "wetZones": "Membrane requise — zones humides",
        "wetZonesHint": "Wet zones, exposition directe à l'eau",
        "pools": "Membrane requise — piscines",
        "bathrooms": "Membrane requise — salles de bain"
      },
      "presealer": {
        "title": "Presealer",
        "numberOfCoats": "Nombre de couches",
        "waitBetweenCoats": "Attente entre couches"
      },
      "sealer": {
        "title": "Sealer standard",
        "ratioA": "Ratio A",
        "ratioAHint": "Partie A du mélange (ex : 5)",
        "ratioB": "Ratio B",
        "ratioBHint": "Partie B du mélange (ex : 1)",
        "mixRestMinutes": "Repos du mélange",
        "numberOfCoats": "Nombre de couches",
        "waitBetweenCoats": "Attente entre couches",
        "fullCureHours": "Cure complète"
      },
      "heavyDuty": {
        "title": "Heavy-Duty Sealer",
        "ratioA": "Ratio A",
        "ratioB": "Ratio B",
        "waitBetweenCoats": "Attente entre couches",
        "fullCureHours": "Cure complète",
        "minTempC": "Temp. min. application",
        "maxTempC": "Temp. max. application",
        "requiredFor": "Heavy-Duty obligatoire pour",
        "floors": "Sols",
        "stairs": "Escaliers",
        "exteriors": "Extérieur",
        "pools": "Piscines",
        "highTraffic": "Zone à trafic élevé"
      },
      "pool": {
        "title": "Règles piscine",
        "fillWaitDays": "Attente avant remplissage",
        "fillWaitHint": "Durée minimum avant remplissage de la piscine",
        "waterlineMarginCm": "Marge ligne eau HD",
        "waterlineMarginHint": "Largeur de zone Heavy-Duty autour de la ligne de flottaison"
      },
      "exterior": {
        "title": "Règles extérieur",
        "minTempC": "Température min.",
        "maxTempC": "Température max."
      },
      "aftercare": {
        "title": "Aftercare et restrictions d'usage",
        "noWaterDays": "Protection absolue",
        "noWaterHint": "Aucun contact ni humidité",
        "noTrafficDays": "Sans trafic",
        "lightUseStartDay": "Usage léger à partir du",
        "normalUseAfterDays": "Usage normal après",
        "resealYearsMin": "Re-sealing recommandé dans",
        "resealYearsMax": "Re-sealing recommandé avant"
      },
      "layerExceptions": {
        "title": "Exceptions système mono/bi-couche",
        "description": "Le système standard Mas Maya est 2 mm couche de base + mesh + 2 mm finition. Ces exceptions ne doivent être activées que pour des surfaces idéales en intérieur sec.",
        "allowOneLayer": "Autoriser système mono-couche sans mesh",
        "allowOneLayerHint": "Murs intérieurs parfaits et secs uniquement",
        "oneLayerWalls": "Mono-couche autorisé sur murs",
        "oneLayerCeilings": "Mono-couche autorisé sur plafonds",
        "allowTwoLayer": "Autoriser bi-couche sans mesh",
        "allowTwoLayerHint": "Murs texturés stables uniquement",
        "twoLayerStableWalls": "Bi-couche sans mesh sur murs texturés stables"
      },
      "underfloorHeating": {
        "title": "Chauffage au sol",
        "warning": "Modifier les paramètres de redémarrage peut impacter la performance du revêtement. Ne modifier ces valeurs que sur recommandation de la documentation technique Mas Maya.",
        "generationTitle": "Génération",
        "generateTasks": "Générer les tâches chauffage au sol",
        "requireQuestion": "Poser la question chauffage pour sections sol",
        "generateShutdown": "Tâche arrêt du chauffage",
        "generateRestart": "Tâches redémarrage du chauffage",
        "generateProgressiveHeatUp": "Redémarrage progressif (tâches par jour)",
        "generateMonitoring": "Tâches de contrôle température",
        "generateClientHandover": "Remise instructions au client",
        "shutdownTitle": "Arrêt avant application",
        "shutdownBeforeApplication": "Heures d'arrêt avant application",
        "shutdownBeforeSealer": "Heures d'arrêt avant sellant",
        "offDuringApplication": "Chauffage éteint pendant application",
        "offDuringCure": "Chauffage éteint pendant cure",
        "restartTitle": "Redémarrage progressif",
        "restartAfterSealer": "Attente après sellant avant redémarrage",
        "restartStartTemp": "Température de départ",
        "restartTempIncrement": "Incrément par jour",
        "restartMaxTemp": "Température maximale",
        "restartMinDuration": "Durée minimale de montée",
        "restartRequiresValidation": "Validation requise à la fin",
        "controlsTitle": "Contrôles",
        "dailyTempCheck": "Contrôle quotidien température",
        "floorSurfaceTempCheck": "Contrôle surface sol avant redémarrage",
        "clientWarningRapidHeatUp": "Avertissement client montée rapide",
        "restartCompletionQc": "QC final après redémarrage"
      }
    },
    "roomCalculation": {
      "title": "Calcul pièce",
      "subtitle": "Coefficients et paramètres pour le calcul de surface des sections de type Pièce",
      "resetTitle": "Réinitialiser les paramètres",
      "resetConfirm": "Toutes les valeurs seront remplacées par les valeurs par défaut. Cette action est irréversible.",
      "surfaceCoefficients": {
        "title": "Coefficients de surface",
        "subtitle": "Multiplicateurs appliqués à la surface sol pour calculer les quantités de matériaux",
        "walls": "Murs",
        "wallsFormula": "surface_murs = sol_m² × (coeff_hauteur − coeff_plafond)",
        "wallsNote": "Le coefficient murs est déduit automatiquement des coefficients hauteur et plafond.",
        "floorCoeff": "Coefficient sol",
        "floorCoeffDesc": "Multiplicateur surface sol (défaut = 1)",
        "ceilingCoeff": "Coefficient plafond",
        "ceilingCoeffDesc": "Multiplicateur surface plafond (défaut = 1)"
      },
      "calculationMode": {
        "title": "Mode de calcul par défaut",
        "label": "Méthode de calcul",
        "description": "Mode utilisé par défaut lors de la création d'une section Pièce",
        "method1": "Méthode 1 — Coefficient rapide",
        "method2": "Méthode 2 — Dimensions exactes",
        "method3": "Méthode 3 — Premium ajusté"
      },
      "heightCoefficients": {
        "title": "Coefficients de hauteur",
        "subtitle": "Coefficient global surface = surface_sol × coefficient (méthode rapide)"
      },
      "geometricMultipliers": {
        "title": "Multiplicateurs géométriques",
        "subtitle": "Facteurs d'ajustement selon le type de pièce",
        "colType": "Type",
        "colLabel": "Libellé",
        "colMin": "Min",
        "colDefault": "Défaut",
        "colMax": "Max"
      },
      "openingDeductions": {
        "title": "Règles de déduction des ouvertures",
        "standardDoors": "Déduire les portes standard",
        "standardWindows": "Déduire les fenêtres standard",
        "largeBays": "Déduire les grandes baies vitrées",
        "shopfronts": "Déduire les devantures de magasin",
        "largeGlassPartitions": "Déduire les grandes cloisons vitrées",
        "thresholdLabel": "Seuil de déduction des grandes ouvertures (m²)",
        "thresholdDesc": "Les ouvertures au-delà de ce seuil sont déduites si la règle correspondante est activée"
      },
      "detailAdditions": {
        "title": "Additions de détail",
        "subtitle": "Pourcentage d'addition pour les détails architecturaux (retours, niches, poutres, caissons, piliers…)",
        "min": "Addition minimale (%)",
        "default": "Addition par défaut (%)",
        "max": "Addition maximale (%)"
      },
      "siteConditions": {
        "title": "Multiplicateurs de condition de chantier",
        "subtitle": "Additions appliquées selon l'état d'occupation du chantier",
        "occupied": "Chantier occupé / meublé",
        "luxury": "Chantier luxe / ultra premium",
        "minimum": "Minimum (%)",
        "maximum": "Maximum (%)"
      },
      "heightAccess": {
        "title": "Multiplicateurs hauteur / accès",
        "subtitle": "Additions appliquées selon la hauteur sous plafond (accès, échafaudage)",
        "standardHeight": "Hauteur standard (0%)",
        "noAddition": "0% — aucune addition"
      },
      "specialFormulas": {
        "title": "Formules géométriques spéciales",
        "beams": "Poutres",
        "beamsFormula": "surface = longueur × Σ faces visibles",
        "beamsNote": "Additionner chaque face visible (dessous, côtés) × longueur",
        "pillars": "Piliers",
        "pillarsFormula": "surface = périmètre × hauteur",
        "pillarsNote": "Périmètre = somme des faces exposées",
        "slopedCeilings": "Plafonds inclinés / rampants",
        "slopedCeilingsFormula": "surface réelle = surface projetée / cos(angle)",
        "slopedCeilingsNote": "L'angle est mesuré par rapport à l'horizontale",
        "niches": "Niches",
        "nichesFormula": "fond + côté gauche + côté droit + haut + bas + retours",
        "nichesNote": "Saisir chaque face individuellement"
      }
    },
    "milestoneWorkflowDesigner": {
      "title": "Workflow Designer",
      "subtitle": "Configurez le parcours de jalons par défaut appliqué à chaque nouveau projet.",
      "addMilestone": "Ajouter un jalon",
      "saveMilestone": "Enregistrer",
      "delete": "Supprimer",
      "unsavedChanges": "Modifications non sauvegardées",
      "sections": {
        "identity": "Identité",
        "triggerEngine": "Moteur de déclenchement",
        "clientVisibility": "Visibilité client",
        "approvalGate": "Porte d'approbation",
        "payment": "Paiement",
        "applicability": "Applicabilité",
        "photoRules": "Règles photo",
        "automation": "Automatisation",
        "notifications": "Notifications"
      },
      "fields": {
        "customTitle": "Titre personnalisé",
        "color": "Couleur",
        "icon": "Icône",
        "type": "Type",
        "scope": "Portée",
        "triggerType": "Déclencheur",
        "triggerCategories": "Catégories déclenchantes",
        "blocksCategories": "Catégories bloquées",
        "isVisibleToClient": "Visible par le client",
        "notifyClient": "Notifier le client",
        "showPhotosToClient": "Afficher les photos au client",
        "showProgress": "Afficher la progression",
        "requiresClientApproval": "Approbation client requise",
        "paymentType": "Type de paiement",
        "paymentPercent": "Pourcentage (%)",
        "paymentAmount": "Montant (€)",
        "appliesToRenovation": "Rénovation",
        "appliesToNewBuild": "Construction neuve",
        "appliesToExternalOnly": "DIY / Externe",
        "appliesToManaged": "Géré Mas Maya",
        "appliesToExecuted": "Exécuté Mas Maya",
        "requirePhotos": "Photos requises",
        "minPhotos": "Photos minimum",
        "photosVisibleToClient": "Photos visibles client",
        "autoComplete": "Complétion automatique",
        "autoNotifyClient": "Notification auto client",
        "autoLockDependentTasks": "Verrouiller tâches dépendantes",
        "autoUnlockAfterApproval": "Déverrouiller après approbation",
        "notifyWorker": "Notifier le poseur",
        "notifyQm": "Notifier le QM",
        "notifyPm": "Notifier le PM"
      },
      "types": {
        "Progress": "Progression",
        "Approval": "Approbation",
        "Payment": "Paiement"
      },
      "scopes": {
        "Project": "Projet",
        "Section": "Surface"
      },
      "triggerTypes": {
        "AllCategoriesCompleted": "Toutes catégories terminées",
        "FirstTaskStarted": "Première tâche démarrée",
        "ProjectArchived": "Projet archivé",
        "Manual": "Manuel"
      },
      "paymentTypes": {
        "None": "Aucun",
        "Percent": "Pourcentage",
        "Fixed": "Montant fixe"
      },
      "categories": {
        "preparation": "Préparation",
        "primer": "Primaire",
        "mesh": "Treillis",
        "baseLayer": "Couche de base",
        "finishingLayer": "Couche de finition",
        "smoothing": "Lissage",
        "presealer": "Présealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer",
        "curing": "Cure",
        "delivery": "Livraison",
        "inspection": "Inspection",
        "handover": "Remise",
        "custom": "Personnalisé"
      },
      "executionModes": {
        "externalOnly": "DIY / Externe",
        "managed": "Géré Mas Maya",
        "executed": "Exécuté Mas Maya"
      },
      "projectTypes": {
        "renovation": "Rénovation",
        "newBuild": "Construction neuve"
      }
    },
    "milestoneTemplateConfig": {
      "title": "Modèles de milestones",
      "description": "Ces paramètres définissent les milestones automatiquement créées sur chaque nouveau projet Mas Maya.",
      "projectMilestones": "Milestones projet",
      "sectionMilestones": "Milestones par surface",
      "save": "Enregistrer",
      "saveSuccess": "Configuration enregistrée.",
      "saveError": "Erreur lors de l'enregistrement.",
      "unsavedWarning": "Des modifications non sauvegardées sont en attente.",
      "m1": {
        "label": "Projet démarré",
        "hint": "Complété automatiquement au démarrage de la première tâche."
      },
      "m2": {
        "label": "Préparation terminée",
        "hint": "Complété quand toutes les tâches Préparation et Primaire sont terminées."
      },
      "m3": {
        "label": "Approbation surface",
        "hint": "Déclenché par section quand les couches de finition sont terminées. Bloque le présealer jusqu'à approbation.",
        "requiresClientApproval": "Approbation client requise",
        "requiresClientApprovalHint": "Le client reçoit un lien unique pour approuver ou rejeter chaque surface."
      },
      "m4": {
        "label": "Protection terminée",
        "hint": "Complété quand toutes les tâches Présealer, Sealer et Heavy-Duty Sealer sont terminées."
      },
      "m5": {
        "label": "Livraison",
        "hint": "Complété automatiquement à l'archivage du projet. Peut inclure un paiement.",
        "paymentType": "Type de paiement",
        "paymentNone": "Aucun",
        "paymentPercent": "Pourcentage",
        "paymentFixed": "Montant fixe",
        "paymentPercentLabel": "Pourcentage (%)",
        "paymentAmountLabel": "Montant (€)"
      }
    }
  },
  "cart": {
    "title": "Panier",
    "empty": "Le panier est vide",
    "clear": "Vider le panier",
    "clearTitle": "Vider le panier",
    "clearConfirm": "Supprimer tous les articles de ce panier ?",
    "clearAction": "Vider",
    "training": "Formation",
    "subtotal": "Sous-total",
    "discount": "Remise",
    "total": "Total",
    "columns": {
      "item": "Article",
      "unitPrice": "Prix unitaire",
      "qty": "Qté",
      "total": "Total"
    },
    "discountReason": {
      "base": "Tarif de base",
      "manual_override": "Remise admin manuelle",
      "cart_training_incentive": "Débloquée par l'ajout de la formation",
      "certification_Basic": "Certification Basic",
      "certification_Intermediate": "Certification Intermédiaire",
      "certification_Expert": "Certification Expert",
      "certification_ExpertFinishes": "Certification Expert Finitions"
    },
    "upsell": {
      "title": "Débloquer une remise",
      "addTraining": "Ajouter {{title}} au panier",
      "level": {
        "Basic": "Basic",
        "Intermediate": "Intermédiaire",
        "Expert": "Expert",
        "ExpertFinishes": "Expert Finitions"
      }
    }
  },
  "staff": {
    "title": "Équipe",
    "createButton": "Nouveau membre",
    "createTitle": "Ajouter un membre",
    "manager": "Responsable",
    "setManager": "Promouvoir responsable",
    "removeManager": "Retirer le rôle de responsable",
    "noData": "Aucun membre trouvé",
    "showInactive": "Afficher inactifs",
    "managers": "Responsables",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "columns": {
      "name": "Nom",
      "email": "E-mail",
      "status": "Statut",
      "manager": "Manager"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "sections": {
      "profile": "Profil"
    },
    "teaching": {
      "title": "Certification professeur",
      "becomeTeacher": "Cet employé est aussi professeur",
      "certifyTitle": "Certifier comme professeur",
      "editTitle": "Modifier la certification",
      "editCertification": "Modifier la certification"
    },
    "schedule": {
      "title": "Planning",
      "date": "Date",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "type": "Type",
      "project": "Projet",
      "notes": "Notes",
      "addEntry": "Ajouter une entrée",
      "empty": "Aucune entrée de planning",
      "removeTitle": "Supprimer l'entrée",
      "removeConfirm": "Êtes-vous sûr de vouloir supprimer cette entrée de planning ?"
    },
    "scheduleType": {
      "ProjectAssignment": "Affectation projet",
      "TrainingSession": "Session de formation",
      "Unavailable": "Indisponible"
    },
    "assignedProjects": "Projets assignés",
    "noAssignedProjects": "Aucun projet assigné",
    "rolePM": "Chef de projet",
    "roleBackupPM": "Chef de projet suppléant",
    "form": {
      "notes": "Notes",
      "firstName": "Prénom",
      "firstNamePlaceholder": "Jean",
      "lastName": "Nom",
      "lastNamePlaceholder": "Dupont",
      "emailRequired": "L'email est requis",
      "firstNameRequired": "Le prénom est requis",
      "lastNameRequired": "Le nom est requis",
      "email": "Email"
    }
  },
  "structures": {
    "title": "Structure",
    "type": "Type de structure",
    "noStructure": "Aucune structure définie",
    "define": "Définir la structure",
    "computedSurface": "Surface calculée",
    "computedVolume": "Volume calculé",
    "deleteTitle": "Supprimer la structure",
    "deleteConfirm": "Supprimer la définition de structure pour cette section ? La surface ne sera pas recalculée."
  },
  "calendar": {
    "title": "Calendrier",
    "mode": {
      "project": "Par projet",
      "staff": "Par employé"
    },
    "labels": {
      "today": "Aujourd'hui",
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois",
      "year": "Année"
    },
    "filters": {
      "categories": "Afficher",
      "allProjects": "Tous les projets",
      "selectProject": "Sélectionner un projet",
      "selectStaff": "Sélectionner un employé",
      "allStatuses": "Tous les statuts",
      "allStepTypes": "Tous les types",
      "allStaff": "Toute l'équipe",
      "allAccounts": "Tous les comptes"
    },
    "categories": {
      "ProjectStep": "Étape chantier",
      "DryingPeriod": "Séchage",
      "CuringPeriod": "Cure",
      "Delivery": "Livraison",
      "Training": "Formation",
      "StaffSchedule": "Planning équipe",
      "Supervision": "Supervision",
      "Personal": "Personnel",
      "ProjectTask": "Tâche projet"
    },
    "taskStatuses": {
      "Todo": "À faire",
      "InProgress": "En cours",
      "SubmittedForReview": "En attente de validation",
      "ValidatedAsTechnicallyCompliant": "Validé",
      "RejectedWithCorrectionRequired": "Rejeté — correction requise",
      "Blocked": "Bloqué"
    },
    "taskCategories": {
      "Preparation": "Préparation",
      "Primer": "Primaire",
      "Mesh": "Armature",
      "BaseLayer": "Couche de base",
      "FinishingLayer": "Couche de finition",
      "Smoothing": "Lissage",
      "Presealer": "Pré-scellant",
      "Sealer": "Scellant",
      "HeavyDutySealer": "Scellant renforcé",
      "Curing": "Cure",
      "Delivery": "Livraison",
      "Inspection": "Inspection",
      "Handover": "Remise de chantier",
      "Custom": "Personnalisé"
    },
    "taskPriorities": {
      "Low": "Faible",
      "Normal": "Normal",
      "High": "Haute",
      "Critical": "Critique"
    },
    "stepTypes": {
      "SubstratePreparation": "Préparation substrat",
      "PrimerApplication": "Application primaire",
      "BaseLayer": "Couche de base",
      "MeshInstallation": "Pose armature",
      "FinishingCoat": "Couche de finition",
      "Smoothing": "Lissage / Ponçage",
      "Presealer": "Pré-scellant",
      "Sealer": "Scellant",
      "HeavyDutySealer": "Scellant renforcé",
      "CuringStep": "Curage",
      "ProtectionPeriod": "Période de protection",
      "Handover": "Remise de chantier"
    },
    "stepStatuses": {
      "Planned": "Planifié",
      "InProgress": "En cours",
      "Completed": "Terminé",
      "Blocked": "Bloqué",
      "ValidationPending": "Validation en attente",
      "CorrectionRequired": "Correction requise",
      "Cancelled": "Annulé"
    },
    "deliveryTypes": {
      "OrderConfirmed": "Commande confirmée",
      "OrderPrepared": "Commande préparée",
      "DeliveryExpected": "Livraison prévue",
      "DeliveryDelayed": "Livraison retardée",
      "DeliveryCompleted": "Livraison effectuée"
    },
    "deliveryStatuses": {
      "Pending": "En attente",
      "InTransit": "En transit",
      "Delivered": "Livré",
      "Delayed": "Retardé",
      "Cancelled": "Annulé"
    },
    "scheduleEntryTypes": {
      "ProjectAssignment": "Affectation chantier",
      "TrainingSession": "Session de formation",
      "Unavailable": "Indisponible"
    },
    "detail": {
      "start": "Début",
      "end": "Fin",
      "project": "Projet",
      "section": "Section",
      "stepType": "Type d'étape",
      "status": "Statut",
      "blocked": "Bloqué",
      "drying": "Période de séchage",
      "curing": "Période de cure",
      "deliveryType": "Type de livraison",
      "deliveryStatus": "Statut livraison",
      "trackingNumber": "Numéro de suivi",
      "carrier": "Transporteur",
      "location": "Lieu",
      "staffMember": "Membre de l'équipe",
      "entryType": "Type d'entrée",
      "notes": "Notes",
      "deleteConfirm": "Voulez-vous vraiment supprimer cet événement ? Cette action est irréversible.",
      "taskStatus": "Statut",
      "taskCategory": "Catégorie",
      "taskPriority": "Priorité",
      "assignedApplicator": "Applicateur",
      "assignedManager": "Chef de projet",
      "validationRequired": "Validation requise",
      "noPlannedDate": "Aucune date planifiée — placé à la date de démarrage du projet"
    },
    "modal": {
      "createStep": "Créer une étape",
      "editStep": "Modifier l'étape",
      "createDelivery": "Créer une livraison",
      "editDelivery": "Modifier la livraison",
      "project": "Projet",
      "stepType": "Type d'étape",
      "customTitle": "Titre personnalisé",
      "customTitlePlaceholder": "Laisser vide pour utiliser le nom du type",
      "date": "Date",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "dryingHours": "Séchage (heures)",
      "curingHours": "Cure (heures)",
      "status": "Statut",
      "notes": "Notes",
      "isBlocked": "Bloqué",
      "blockedReason": "Raison du blocage",
      "deliveryType": "Type de livraison",
      "deliveryStatus": "Statut",
      "expectedDate": "Date prévue",
      "actualDate": "Date de livraison effective",
      "trackingNumber": "Numéro de suivi",
      "carrier": "Transporteur"
    }
  },
  "supervision": {
    "title": "Supervision",
    "tabs": {
      "comments": "Commentaires",
      "observations": "Observations",
      "escalations": "Escalades",
      "history": "Historique"
    },
    "visibility": {
      "label": "Visibilité",
      "ClientVisible": "Visible client",
      "TeamVisible": "Équipe seulement",
      "InternalOnly": "Interne uniquement"
    },
    "comments": {
      "empty": "Aucun commentaire.",
      "newPlaceholder": "Écrire un commentaire…",
      "replyPlaceholder": "Écrire une réponse…",
      "send": "Envoyer",
      "reply": "Répondre",
      "deleted": "[supprimé]"
    },
    "observations": {
      "empty": "Aucune observation enregistrée.",
      "open": "ouverte(s)",
      "resolvedCount": "résolue(s)",
      "add": "Ajouter une observation",
      "titleLabel": "Titre",
      "bodyLabel": "Description",
      "severityLabel": "Sévérité",
      "by": "par",
      "resolved": "Résolue",
      "resolve": "Marquer comme résolue",
      "confirmResolve": "Confirmer",
      "resolutionNote": "Note de résolution",
      "resolveNotePlaceholder": "Décrivez comment cela a été résolu…",
      "severity": {
        "Info": "Info",
        "Warning": "Avertissement",
        "Critical": "Critique"
      }
    },
    "escalations": {
      "empty": "Aucune escalade.",
      "open": "ouverte(s)",
      "resolvedCount": "résolue(s)",
      "new": "Nouvelle escalade",
      "subjectLabel": "Objet",
      "bodyLabel": "Description",
      "submit": "Soumettre",
      "by": "par",
      "assignedTo": "Assigné à",
      "resolution": "Résolution",
      "resolutionLabel": "Note de résolution",
      "statusLabel": "Nouveau statut",
      "updateStatus": "Mettre à jour le statut",
      "status": {
        "Open": "Ouvert",
        "Acknowledged": "Pris en charge",
        "Resolved": "Résolu"
      }
    },
    "auditLog": {
      "empty": "Aucune activité enregistrée.",
      "loadMore": "Charger plus",
      "actions": {
        "ProjectCreated": "a créé le projet",
        "ProjectUpdated": "a mis à jour le projet",
        "ProjectStatusChanged": "a changé le statut du projet",
        "ProjectDeleted": "a supprimé le projet",
        "StepCreated": "a créé une étape",
        "StepUpdated": "a mis à jour une étape",
        "StepStatusChanged": "a changé le statut d'une étape",
        "StepDeleted": "a supprimé une étape",
        "StepBlocked": "a bloqué une étape",
        "StepUnblocked": "a débloqué une étape",
        "StepValidated": "a validé une étape",
        "StepRejected": "a rejeté une étape",
        "DeliveryCreated": "a créé une livraison",
        "DeliveryUpdated": "a mis à jour une livraison",
        "DeliveryStatusChanged": "a changé le statut d'une livraison",
        "DeliveryDeleted": "a supprimé une livraison",
        "ApplicatorAssigned": "a assigné un applicateur",
        "ApplicatorRemoved": "a retiré un applicateur",
        "TeamMemberAssigned": "a assigné un membre d'équipe",
        "TeamMemberRemoved": "a retiré un membre d'équipe",
        "BackupPmAssigned": "a assigné un PM suppléant",
        "ClientLinked": "a lié un client",
        "DocumentUploaded": "a téléversé un document",
        "DocumentDeleted": "a supprimé un document",
        "CommentAdded": "a ajouté un commentaire",
        "CommentDeleted": "a supprimé un commentaire",
        "ObservationAdded": "a enregistré une observation",
        "ObservationResolved": "a résolu une observation",
        "EscalationCreated": "a créé une escalade",
        "EscalationAcknowledged": "a pris en charge une escalade",
        "EscalationResolved": "a résolu une escalade"
      }
    }
  },
  "roles": {
    "GlobalAdmin": "Super Admin",
    "Admin": "Administrateur",
    "ProjectManager": "Chef de projet",
    "BackupProjectManager": "Chef de projet adjoint",
    "MasMayaApplicator": "Applicateur Mas Maya",
    "ReferencedInstaller": "Installateur référencé",
    "IndividualClient": "Client particulier",
    "ProfessionalClient": "Client professionnel"
  },
  "userManagement": {
    "title": "Gestion des utilisateurs",
    "users": "utilisateurs",
    "searchPlaceholder": "Rechercher par nom ou email…",
    "noRoles": "Aucun rôle attribué",
    "noUsers": "Aucun utilisateur trouvé",
    "addRole": "Ajouter un rôle",
    "impersonate": "Incarner",
    "impersonatingAs": "Connecté en tant que {{name}}",
    "stopImpersonating": "Arrêter l'incarnation",
    "columns": {
      "user": "Utilisateur",
      "roles": "Rôles",
      "entities": "Entités"
    },
    "removeRole": {
      "title": "Retirer le rôle",
      "confirm": "Retirer le rôle {{role}} de {{user}} ?"
    }
  },
  "shop": {
    "nav": "Boutique",
    "hero": {
      "title": "Systèmes de Finition",
      "subtitle": "Enduits, Primaires & Accessoires",
      "description": "Matériaux de finition architecturale pour les artisans exigeants."
    },
    "allProducts": "Tous les produits",
    "searchPlaceholder": "Rechercher un produit...",
    "noResults": "Aucun produit trouvé",
    "filterBy": "Filtrer par",
    "sortBy": "Trier par",
    "sort": {
      "nameAsc": "Nom (A–Z)",
      "priceAsc": "Prix croissant",
      "priceDesc": "Prix décroissant"
    },
    "addToCart": "Ajouter au panier",
    "addedToCart": "Ajouté au panier",
    "viewDetails": "Voir le produit",
    "backToShop": "Retour à la boutique",
    "relatedProducts": "Produits complémentaires",
    "systemNote": "Ces produits font partie d'un système complet d'application.",
    "selectContact": "Sélectionner un client",
    "selectContactHint": "Choisissez un client pour gérer son panier.",
    "cartFor": "Panier de",
    "openCart": "Voir le panier",
    "cart": {
      "title": "Panier",
      "empty": "Le panier est vide.",
      "checkout": "Finaliser la commande",
      "orderOnMasmaya": "Commander sur masmaya.com"
    },
    "qty": "Qté",
    "details": {
      "category": "Catégorie",
      "variant": "Variante",
      "color": "Couleur",
      "sizeWeight": "Taille / Poids",
      "dimensions": "Dimensions",
      "sku": "Référence",
      "price": "Prix",
      "technical": "Informations techniques"
    }
  },
  "applicatorProfiles": {
    "title": "Fiches applicateurs",
    "createTitle": "Créer un profil applicateur",
    "moderateTitle": "Modérer la photo",
    "form": {
      "contactId": "ID Contact",
      "contactIdPlaceholder": "Coller l'UUID du contact",
      "contactIdRequired": "L'ID contact est requis",
      "displayName": "Nom affiché",
      "displayNameRequired": "Le nom affiché est requis",
      "companyName": "Nom de l'entreprise",
      "bio": "Biographie",
      "city": "Ville",
      "country": "Pays (code 2 lettres)",
      "travelRadius": "Rayon de déplacement (km)",
      "yearsExperience": "Années d'expérience",
      "availability": "Disponibilité",
      "specialties": "Spécialités",
      "styleTags": "Tags style",
      "technicalTags": "Systèmes techniques",
      "note": "Note (visible admin uniquement)",
      "newStatus": "Nouveau statut"
    },
    "availability": {
      "Available": "Disponible",
      "PartiallyBooked": "Partiellement réservé",
      "Unavailable": "Indisponible"
    },
    "moderation": {
      "PendingReview": "En attente de revue",
      "Approved": "Approuvé",
      "Rejected": "Refusé",
      "Hidden": "Masqué",
      "Featured": "Mis en avant"
    },
    "currentStatus": "Statut actuel :",
    "deleteConfirm": "Supprimer ce profil applicateur ?",
    "deleteTitle": "Supprimer le profil"
  }
}
